export const QUESTIONS = [
  {
    "id": 1,
    "question": "An AI-driven medical diagnostic system misclassifies a patient’s condition due to biased training data. Which principle of responsible AI is most directly violated?",
    "choice_a": "Transparency",
    "choice_b": "Fairness",
    "choice_c": "Security",
    "choice_d": "Human-centricity",
    "correct_answer": "B",
    "explanation": "Fairness requires that AI systems produce equitable outcomes and avoid discrimination caused by biased data. When an AI diagnostic tool generates inconsistent or discriminatory results, it reflects bias present in the training dataset. Transparency helps explain the AI system’s decision, but fairness is the principle that ensures equitable treatment for all individuals.",
    "topic_id": 3,
    "practice_test_id": 1,
    "related_articles": [
      507,
      520,
      481,
      554,
      575
    ],
    "source": "363940_AssessmentTest"
  },
  {
    "id": 2,
    "question": "An autonomous delivery robot is programmed to make decisions without human intervention. What governance safeguard should be in place to manage this AI system?",
    "choice_a": "Implementation of a human-in-the-loop mechanism",
    "choice_b": "Strict limitation of opacity",
    "choice_c": "Use of supervised learning only",
    "choice_d": "Elimination of data dependency",
    "correct_answer": "A",
    "explanation": "Autonomous systems introduce governance challenges because they act independently. A human-in-the-loop mechanism ensures oversight and allows intervention when autonomous behavior produces unsafe or unintended outcomes. This control supports accountability and reduces operational and ethical risks.",
    "topic_id": 4,
    "practice_test_id": 1,
    "related_articles": [
      430,
      259,
      548,
      547,
      427
    ],
    "source": "363940_AssessmentTest"
  },
  {
    "id": 3,
    "question": "A company uses generative AI to design marketing materials trained on copyrighted online content. What AI characteristic primarily drives the need for governance in this case?",
    "choice_a": "Probabilistic outputs",
    "choice_b": "Complexity",
    "choice_c": "Speed and scale",
    "choice_d": "Data dependency",
    "correct_answer": "D",
    "explanation": "AI systems rely heavily on large volumes of training data, which may include copyrighted or proprietary material. This dependence introduces legal and ethical risks, making data dependency a key governance concern. Effective AI governance frameworks require processes to verify data provenance, manage intellectual property exposure, maintain data lineage, and ensure lawful use of all training inputs.",
    "topic_id": 1,
    "practice_test_id": 1,
    "related_articles": [
      30,
      31,
      120,
      146,
      157
    ],
    "source": "363940_AssessmentTest"
  },
  {
    "id": 4,
    "question": "An organization’s AI governance board notices recurring gaps between technical and legal interpretations of “acceptable model risk.” Which structural action would best strengthen cross-functional collaboration?",
    "choice_a": "Assign each department its own separate governance policy.",
    "choice_b": "Require periodic joint review meetings and shared documentation templates.",
    "choice_c": "Eliminate legal participation in technical discussions to reduce friction.",
    "choice_d": "Move all governance decisions to the IT department.",
    "correct_answer": "B",
    "explanation": "Cross-functional collaboration depends on shared processes and transparent communication. Regular joint review meetings supported by standard templates ensure alignment between technical precision and regulatory requirements. Separate or siloed policies create inconsistencies, and removing stakeholders can reduce oversight rather than improve it.",
    "topic_id": 1,
    "practice_test_id": 1,
    "related_articles": [
      74,
      75,
      105,
      63,
      76
    ],
    "source": "363940_AssessmentTest"
  },
  {
    "id": 5,
    "question": "A mid-sized financial services company wants to expand its AI program. Which governance maturity action should it prioritize next?",
    "choice_a": "Create a lightweight checklist with no documentation requirements.",
    "choice_b": "Focus exclusively on model accuracy metrics.",
    "choice_c": "Formalize lifecycle checkpoints such as fairness reviews and deployment approval gates.",
    "choice_d": "Replace the governance council with ad hoc task forces.",
    "correct_answer": "C",
    "explanation": "Organizations transitioning from informal to managed maturity should embed governance checkpoints throughout the AI lifecycle. Structured reviews, including bias testing and documentation gates, institutionalize accountability and readiness. Accuracy alone is insufficient, and ad hoc governance erodes traceability.",
    "topic_id": 1,
    "practice_test_id": 1,
    "related_articles": [
      63,
      97,
      123,
      117,
      122
    ],
    "source": "363940_AssessmentTest"
  },
  {
    "id": 6,
    "question": "In a global healthcare enterprise, the AI governance team includes executives, clinicians, and data scientists. Which factor most justifies maintaining this diverse membership?",
    "choice_a": "Diversity increases model training speed.",
    "choice_b": "Cross-functional expertise ensures balanced evaluation of technical, ethical, and clinical risks.",
    "choice_c": "It satisfies minimum staffing requirements for compliance audits.",
    "choice_d": "It reduces total program cost through redundancy elimination.",
    "correct_answer": "B",
    "explanation": "AI governance in regulated sectors requires multiple perspectives to detect complex risks. Including technical, operational, and ethical experts ensures decisions account for safety, fairness, and compliance obligations. Diversity of expertise is a risk-control mechanism.",
    "topic_id": 1,
    "practice_test_id": 1,
    "related_articles": [
      74,
      61,
      75,
      62,
      105
    ],
    "source": "363940_AssessmentTest"
  },
  {
    "id": 7,
    "question": "An organization integrates AI governance into its existing IT governance framework rather than managing them separately. What is the primary benefit of this combined approach?",
    "choice_a": "It avoids duplication and embeds AI oversight into established processes.",
    "choice_b": "It eliminates the need for privacy and security policies.",
    "choice_c": "It prevents non-technical staff from influencing AI decisions.",
    "choice_d": "It removes the requirement for lifecycle documentation.",
    "correct_answer": "A",
    "explanation": "Integrating AI governance into existing IT governance creates operational efficiency by leveraging existing review, approval, and documentation processes. These processes ensure AI-specific controls, such as fairness testing and model monitoring, fit within established workflows, reducing duplication and improving consistency and scalability across systems and processes.",
    "topic_id": 1,
    "practice_test_id": 1,
    "related_articles": [
      97,
      63,
      105,
      117,
      75
    ],
    "source": "363940_AssessmentTest"
  },
  {
    "id": 8,
    "question": "During a vendor assessment, a company discovers that a third-party AI model uses publicly scraped data with uncertain consent. Which governance control would best address this risk?",
    "choice_a": "Requiring the vendor to provide documentation of data sources and licensing",
    "choice_b": "Allowing deployment since the data is publicly available",
    "choice_c": "Ignoring data provenance if the model performs accurately",
    "choice_d": "Adding a confidentiality clause unrelated to data sourcing",
    "correct_answer": "A",
    "explanation": "Vendor transparency regarding training data sources and usage rights is an essential AI governance control. Policies and contracts should require vendors to disclose provenance and licensing to ensure compliance with data protection and intellectual property laws. The public availability of data does not exempt individuals from the obligation to verify lawful use.",
    "topic_id": 3,
    "practice_test_id": 1,
    "related_articles": [
      480,
      404,
      497,
      464,
      479
    ],
    "source": "363940_AssessmentTest"
  },
  {
    "id": 9,
    "question": "An AI chatbot trained on historical customer interactions begins generating responses that reveal fragments of personal data. Which policy area most urgently needs revision?",
    "choice_a": "Access control and password management",
    "choice_b": "Network performance optimization",
    "choice_c": "Facilities security and visitor access procedures",
    "choice_d": "Traditional data retention and anonymization standards",
    "correct_answer": "D",
    "explanation": "Leakage of memorized personal data from AI outputs highlights weaknesses in traditional data retention and anonymization policies. AI governance must expand these controls to include differential privacy, data minimization, and lifecycle-based retention, recognizing that models can unintentionally preserve sensitive information long after data ingestion.",
    "topic_id": 2,
    "practice_test_id": 1,
    "related_articles": [
      176,
      181,
      316,
      177,
      187
    ],
    "source": "363940_AssessmentTest"
  },
  {
    "id": 10,
    "question": "An AI system trained on social media text begins predicting users’ religious beliefs, even though this attribute was never directly collected. What obligation does this create under privacy law?",
    "choice_a": "None, since the system never collected explicit religion data.",
    "choice_b": "The inference counts as processing of special category data and triggers GDPR Article 9 safeguards.",
    "choice_c": "Only a transparency notice update is required.",
    "choice_d": "It qualifies as anonymous data because it was inferred.",
    "correct_answer": "B",
    "explanation": "Under GDPR Article 9, processing special-category (sensitive) data, including religious or political beliefs, is prohibited unless a lawful exception applies. Inferred attributes are still personal data if they reveal protected categories. Controllers must identify and document a legal basis, conduct a DPIA, and implement technical and organizational safeguards to prevent discrimination or misuse.",
    "topic_id": 2,
    "practice_test_id": 1,
    "related_articles": [
      207,
      210,
      212,
      187,
      208
    ],
    "source": "363940_AssessmentTest"
  },
  {
    "id": 11,
    "question": "A multinational bank relies on a cloud-based AI model hosted in another region. What must the controller do to comply with GDPR transfer obligations?",
    "choice_a": "Encrypt model outputs but skip documentation.",
    "choice_b": "Obtain verbal consent from customers for each transfer.",
    "choice_c": "Conduct a Transfer Impact Assessment (TIA) and ensure valid safeguards such as SCCs or BCRs.",
    "choice_d": "Rely on processor confidentiality clauses alone.",
    "correct_answer": "C",
    "explanation": "Cross-border AI processing constitutes an international data transfer under GDPR. Controllers must assess the destination country’s privacy laws, apply an approved safeguard (typically Standard Contractual Clauses—SCCs) or Binding Corporate Rules—BCRs), and document their findings in a TIA. These safeguards ensure lawful transfer and accountability for data processed outside the European Economic Area (EEA).",
    "topic_id": 2,
    "practice_test_id": 1,
    "related_articles": [
      189,
      188,
      192,
      181,
      187
    ],
    "source": "363940_AssessmentTest"
  },
  {
    "id": 12,
    "question": "A company developing an emotion-recognition tool processes voice recordings containing biometric and health cues. Which governance control is most essential before deployment?",
    "choice_a": "Marketing approval from the product team",
    "choice_b": "Execution of a Data Protection Impact Assessment (DPIA) addressing risks to data subjects",
    "choice_c": "Annual employee privacy training",
    "choice_d": "Generic system penetration testing",
    "correct_answer": "B",
    "explanation": "Processing biometric or health data represents a high-risk activity under GDPR Article 35 and mandates a DPIA. The assessment documents processing purpose, data sensitivity, potential harms, and mitigation measures such as encryption, consent management, and bias testing. Without a DPIA, controllers cannot demonstrate compliance or justify the lawful basis for handling sensitive data.",
    "topic_id": 2,
    "practice_test_id": 1,
    "related_articles": [
      187,
      208,
      216,
      177,
      207
    ],
    "source": "363940_AssessmentTest"
  },
  {
    "id": 13,
    "question": "A generative-AI platform trains on millions of online articles under the assumption that scraping constitutes “fair use.” Which factor would most weaken its fair-use defense?",
    "choice_a": "The model’s outputs are non-commercial.",
    "choice_b": "The model’s training is transformative rather than duplicative.",
    "choice_c": "The system reproduces recognizable portions of protected works.",
    "choice_d": "The data come from publicly accessible sources.",
    "correct_answer": "C",
    "explanation": "Fair use depends partly on whether the new use is transformative and whether it affects the market for the original work. If an AI system reproduces identifiable or substantial parts of copyrighted material, the use is not transformative and undermines the fair-use claim—even if the data were publicly available.",
    "topic_id": 2,
    "practice_test_id": 1,
    "related_articles": [
      231,
      233,
      234,
      235,
      232
    ],
    "source": "363940_AssessmentTest"
  },
  {
    "id": 14,
    "question": "An AI-based credit-scoring tool uses a consumer’s postal code as a model feature. Under anti-discrimination law, what is the primary concern?",
    "choice_a": "Postal code can act as a proxy for protected classes, producing disparate impact.",
    "choice_b": "The feature may reduce model accuracy.",
    "choice_c": "The feature violates open-banking data-sharing rules.",
    "choice_d": "The feature requires explicit customer consent under the FCRA.",
    "correct_answer": "A",
    "explanation": "Postal codes often correlate with protected traits such as race, income, and other characteristics. Even without intent to discriminate, their inclusion can result in disparate impacts prohibited by laws such as the Equal Credit Opportunity Act (ECOA) and the Fair Housing Act. Models must test and justify any variable that could serve as a proxy for protected traits.",
    "topic_id": 2,
    "practice_test_id": 1,
    "related_articles": [
      254,
      256,
      257,
      258,
      211
    ],
    "source": "363940_AssessmentTest"
  },
  {
    "id": 15,
    "question": "A home-robot manufacturer releases a firmware update that introduces erratic movement, causing property damage. Which legal theory most likely applies?",
    "choice_a": "Manufacturing defect",
    "choice_b": "Design defect",
    "choice_c": "Failure to warn",
    "choice_d": "Breach of warranty",
    "correct_answer": "A",
    "explanation": "When a product deviates from its intended design due to an error during production or update deployment, it constitutes a manufacturing defect. Even if the original design was sound, an improperly executed firmware change that causes harm triggers strict liability under product liability law. If the update was improperly executed, it is considered a manufacturing defect; if the update design itself was unsafe, it could be a design defect. For exam purposes, a manufacturing defect is the best fit.",
    "topic_id": 2,
    "practice_test_id": 1,
    "related_articles": [
      296,
      294,
      295,
      299,
      298
    ],
    "source": "363940_AssessmentTest"
  },
  {
    "id": 16,
    "question": "An AI system used to rank citizens based on their social behavior would violate which element of the EU AI Act?",
    "choice_a": "Limited-risk AI disclosure obligations",
    "choice_b": "High-risk AI documentation requirements",
    "choice_c": "Prohibited AI classification",
    "choice_d": "Systemic-risk designation for GPAI",
    "correct_answer": "C",
    "explanation": "Social scoring systems by governments are explicitly prohibited under the EU AI Act. These systems are considered incompatible with EU values and fundamental rights because they create discriminatory and manipulative effects that cannot be mitigated by controls or transparency.",
    "topic_id": 2,
    "practice_test_id": 1,
    "related_articles": [
      311,
      317,
      316,
      216,
      332
    ],
    "source": "363940_AssessmentTest"
  },
  {
    "id": 17,
    "question": "Before a high-risk AI system can be marketed within the EU, what must its provider complete?",
    "choice_a": "Certification from the European AI Office only",
    "choice_b": "A conformity assessment and CE marking process",
    "choice_c": "An EU-level procurement review",
    "choice_d": "Submission of its algorithm source code to regulators",
    "correct_answer": "B",
    "explanation": "High-risk AI systems must undergo conformity assessment (either with a qualified internal resource or via a third-party Notified Body), and achieve CE marking before entering the market. This process verifies compliance with safety, transparency, and oversight obligations. Regulators do not require the disclosure of proprietary source code, but they do require traceable documentation and auditability.",
    "topic_id": 2,
    "practice_test_id": 1,
    "related_articles": [
      317,
      311,
      337,
      316,
      216
    ],
    "source": "363940_AssessmentTest"
  },
  {
    "id": 18,
    "question": "A company outside the EU develops a general-purpose AI model that is integrated into multiple EU applications. Which step ensures compliance with the EU AI Act’s legal requirements?",
    "choice_a": "Applying for an EU data adequacy determination",
    "choice_b": "Requesting exemption from systemic-risk classification",
    "choice_c": "Registering the model only in the developer’s home country",
    "choice_d": "Appointing an EU-based legal representative and maintaining conformity documentation",
    "correct_answer": "D",
    "explanation": "The EU AI Act has extraterritorial reach. Non-EU providers placing AI systems on the EU market must designate a legal representative within the EU to liaise with regulators, ensure conformity assessments, and maintain documentation. This requirement extends to general-purpose AI (GPAI) models integrated into downstream EU-facing applications.",
    "topic_id": 2,
    "practice_test_id": 1,
    "related_articles": [
      333,
      338,
      322,
      323,
      332
    ],
    "source": "363940_AssessmentTest"
  },
  {
    "id": 19,
    "question": "Which statement best describes the relationship between the NIST AI RMF and NIST ARIA?",
    "choice_a": "ARIA replaces the AI RMF as a legally required framework for federal agencies.",
    "choice_b": "The AI RMF provides strategic guidance, while ARIA offers tools to operationalize it.",
    "choice_c": "The AI RMF applies only to cybersecurity, while ARIA applies to AI ethics.",
    "choice_d": "ARIA focuses on model training, while the AI RMF addresses licensing.",
    "correct_answer": "B",
    "explanation": "The NIST AI Risk Management Framework (AI RMF) defines strategic goals and functions (Govern, Map, Measure, and Manage) for managing AI risk. The NIST Assurance of AI Systems (ARIA) program builds on it by providing concrete tools, metrics, and implementation pathways to translate those principles into operational practice, particularly for public-sector organizations. ARIA is a research initiative providing methods and metrics to operationalize the AI RMF; it does not replace or supersede the RMF.",
    "topic_id": 2,
    "practice_test_id": 1,
    "related_articles": [
      375,
      349,
      374,
      354,
      178
    ],
    "source": "363940_AssessmentTest"
  },
  {
    "id": 20,
    "question": "According to ISO/IEC 42001, what is the purpose of integrating AI governance with existing management systems, such as ISO/IEC 27001 or ISO 9001?",
    "choice_a": "To streamline certification processes and promote unified governance",
    "choice_b": "To eliminate redundant controls by removing human oversight",
    "choice_c": "To replace cybersecurity management with AI management",
    "choice_d": "To prioritize algorithmic speed over quality management",
    "correct_answer": "A",
    "explanation": "The ISO/IEC 42001 standard mirrors the structure of other ISO standards, allowing organizations to integrate AI governance into established quality or information security management systems. This approach consolidates documentation, audits, and improvement processes, strengthening organizational coherence while reducing redundancy.",
    "topic_id": 2,
    "practice_test_id": 1,
    "related_articles": [
      383,
      382,
      182,
      350,
      354
    ],
    "source": "363940_AssessmentTest"
  },
  {
    "id": 21,
    "question": "How does ISO/IEC 22989 help organizations engaged in AI governance?",
    "choice_a": "It defines a legal enforcement framework for AI-related misconduct.",
    "choice_b": "It establishes certification rules for high-risk AI applications.",
    "choice_c": "It provides a standard lexicon to ensure consistency in terminology and communication.",
    "choice_d": "It mandates disclosure of proprietary algorithms to regulators.",
    "correct_answer": "C",
    "explanation": "ISO/IEC 22989 standardizes definitions of key AI terms, such as transparency, autonomy, and explainability, thereby creating a shared vocabulary for developers, policymakers, and auditors. Adopting these standard terms reduces ambiguity in technical documentation and contracts, thereby promoting cross-sector and cross-border alignment in AI governance.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      381,
      395,
      384,
      345,
      182
    ],
    "source": "363940_AssessmentTest"
  },
  {
    "id": 22,
    "question": "During the design phase, an organization selects a highly complex deep learning model even though a simpler one would meet performance goals. Which governance issue does this decision most directly raise?",
    "choice_a": "Transparency and explainability risk",
    "choice_b": "Data sovereignty compliance",
    "choice_c": "Vendor lock-in",
    "choice_d": "Infrastructure scalability",
    "correct_answer": "A",
    "explanation": "Overly complex models often reduce explainability and transparency. Governance frameworks emphasize model interpretability as a cornerstone of accountability, particularly in regulated sectors. When simpler, equally effective alternatives exist, complexity adds unnecessary governance burden and can obscure bias or error analysis. Additional complexity also increases the attack surface, potentially making it more difficult to protect such a system from malicious input and other forms of attack. Finally, additional complexity increases the governance burden by requiring additional effort to assess, monitor, and mitigate issues.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      465,
      507,
      442,
      576,
      536
    ],
    "source": "363940_AssessmentTest"
  },
  {
    "id": 23,
    "question": "A financial institution completes its AI impact assessment but fails to implement the mitigation steps it identified. What governance failure does this represent?",
    "choice_a": "Poor system documentation",
    "choice_b": "Lack of operationalization and review of assessment results",
    "choice_c": "Overclassification of model risk",
    "choice_d": "Duplication of regulatory filings",
    "correct_answer": "B",
    "explanation": "Impact assessments are only effective if their findings are reviewed, approved, and integrated into development and deployment processes. Failing to act on assessment results undermines the purpose of the AIA and reflects a breakdown in the feedback loop essential to continuous governance improvement. Note that a decision to accept any individual risk is permissible, provided it is made in accordance with defined governance roles and responsibilities.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      431,
      565,
      430,
      546,
      596
    ],
    "source": "363940_AssessmentTest"
  },
  {
    "id": 24,
    "question": "In designing a proprietary AI system, which practice most effectively reduces downstream legal and operational risk?",
    "choice_a": "Allowing data scientists to change model parameters without recordkeeping",
    "choice_b": "Using internal data without confirming its lawful basis for processing",
    "choice_c": "Outsourcing data collection to anonymous contractors",
    "choice_d": "Embedding documentation, testing, and explainability into the design process",
    "correct_answer": "D",
    "explanation": "Governance, testing, and explainability controls included in the design phase create defensibility and traceability throughout the lifecycle. Proper documentation and transparency enable organizations to demonstrate compliance and respond to audits or litigation.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      119,
      124,
      122,
      117,
      41
    ],
    "source": "363940_AssessmentTest"
  },
  {
    "id": 25,
    "question": "A company trains an AI model using data purchased from a third-party broker. Later, it discovers that the broker lacked the legal authority to sell the data. Which governance control should have prevented this issue?",
    "choice_a": "Bias and fairness testing",
    "choice_b": "Verification of lawful data rights and provenance documentation",
    "choice_c": "Integration testing before deployment",
    "choice_d": "Regularization during model training",
    "correct_answer": "B",
    "explanation": "Before any dataset is used for AI development, governance controls must verify lawful collection, usage rights, and provenance documentation. These controls include reviewing contracts, consent records, and regulatory compliance. Failure to confirm these rights exposes organizations to legal and ethical liabilities, even when the model performs correctly.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      480,
      464,
      416,
      497,
      482
    ],
    "source": "363940_AssessmentTest"
  },
  {
    "id": 26,
    "question": "An AI system trained on clean, representative data begins producing biased results several months after deployment. What governance issue is the most likely cause?",
    "choice_a": "Lack of data drift monitoring and retraining protocols",
    "choice_b": "Overfitting during initial training",
    "choice_c": "Failure to anonymize personal data",
    "choice_d": "Use of synthetic data augmentation",
    "correct_answer": "A",
    "explanation": "Data drift occurs when live input data diverges from the distribution of training data, degrading performance and fairness. Governance frameworks should require ongoing monitoring and retraining to ensure the continued validity of AI models. Without these checks, models can silently accumulate bias or inaccuracies over time.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      554,
      553,
      555,
      521
    ],
    "source": "363940_AssessmentTest"
  },
  {
    "id": 27,
    "question": "During model validation, developers notice that results differ each time the model is retrained, even with identical data. Which testing or governance control addresses this risk?",
    "choice_a": "Ensuring model determinism through seed control and documented configurations",
    "choice_b": "Expanding the dataset with more examples",
    "choice_c": "Applying dropout regularization",
    "choice_d": "Replacing validation testing with performance testing",
    "correct_answer": "A",
    "explanation": "Reproducibility is a cornerstone of responsible AI governance. Controlling random seeds, recording hyperparameters, and documenting configurations ensure that models produce consistent results across retraining. These efforts support auditability, transparency, and regulatory defensibility when AI decisions are challenged.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      404,
      505,
      405,
      521,
      465
    ],
    "source": "363940_AssessmentTest"
  },
  {
    "id": 28,
    "question": "An AI customer support chatbot begins generating inaccurate responses after six months in production. Which governance control should have detected this issue earlier?",
    "choice_a": "Regular penetration testing",
    "choice_b": "Human-in-the-loop decision approval",
    "choice_c": "Scheduled retraining and performance monitoring",
    "choice_d": "Fine-tuning with anonymized data",
    "correct_answer": "C",
    "explanation": "Continuous monitoring and scheduled retraining are core governance practices to maintain AI system performance and accuracy over time. As data distributions and user interactions evolve, models degrade without routine evaluation. Governance frameworks should require regular retraining intervals and performance thresholds to detect drift or loss of accuracy before it harms customers.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      555,
      554,
      553,
      521,
      578
    ],
    "source": "363940_AssessmentTest"
  },
  {
    "id": 29,
    "question": "Before deploying a high-risk AI model, a governance team confirms that documentation, risk mitigation plans, and monitoring plans are complete. What governance mechanism is being applied?",
    "choice_a": "Post-market surveillance",
    "choice_b": "Final gate review and stakeholder signoff",
    "choice_c": "Shadow modeling for drift detection",
    "choice_d": "Automated rollback testing",
    "correct_answer": "B",
    "explanation": "Final gate reviews are structured checkpoints to ensure all regulatory, technical, and ethical requirements are met before release. This governance step provides traceability, formal approval, and accountability from all stakeholders—including legal, engineering, business, and risk—before production deployment.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      546,
      431,
      565,
      427,
      430
    ],
    "source": "363940_AssessmentTest"
  },
  {
    "id": 30,
    "question": "A healthcare provider deploys an AI diagnostic tool that runs on hospital devices without requiring cloud access. Which deployment model does this represent, and why is it appropriate?",
    "choice_a": "Cloud deployment—ensures centralized control and scalability",
    "choice_b": "Edge deployment—provides low latency and preserves patient privacy",
    "choice_c": "On-premises deployment—simplifies external vendor management",
    "choice_d": "Hybrid deployment—balances accuracy and interpretability",
    "correct_answer": "B",
    "explanation": "Edge deployment processes data locally, minimizing latency and protecting sensitive information by avoiding data transmission to cloud servers. This approach aligns with healthcare privacy and safety obligations, where both speed and confidentiality are critical governance priorities. On-premises would have been the next-best strategy and may be used when edge devices constrain or prevent edge deployment. On‐premises deployment also enhances privacy, but edge deployment is preferred for latency‐sensitive healthcare use.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      213,
      546,
      547,
      7,
      565
    ],
    "source": "363940_AssessmentTest"
  },
  {
    "id": 31,
    "question": "An organization integrates an open-source AI model licensed under AGPL into its commercial product. What is the most significant risk if the licensing terms are not appropriately reviewed?",
    "choice_a": "The organization may be required to disclose proprietary source code.",
    "choice_b": "The model could fail to meet expected performance benchmarks.",
    "choice_c": "Users could access the model through unauthorized APIs.",
    "choice_d": "The license automatically converts to the public domain after release.",
    "correct_answer": "A",
    "explanation": "The GNU Affero General Public License (AGPL) requires that derivative works and network-accessible implementations make their source code available to users. Failing to comply exposes the organization to intellectual property violations, threatening reputational risk. A legal review of open-source license terms (and all other relevant legal agreements) is a critical element of AI vendor and component risk management.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      233,
      299,
      350,
      349,
      316
    ],
    "source": "363940_AssessmentTest"
  },
  {
    "id": 32,
    "question": "During an AI system audit, a red team successfully manipulates a chatbot into revealing fragments of its training data. Which risk domain does this finding most directly relate to?",
    "choice_a": "Operational risk",
    "choice_b": "Ethical and social risk",
    "choice_c": "Deployment risk",
    "choice_d": "Data-related risk",
    "correct_answer": "D",
    "explanation": "Exposing fragments of training data represents an AI-specific data-related risk, involving data leakage and privacy breaches. Red team testing helps uncover these vulnerabilities before adversaries can exploit them. Strong data governance and differential privacy mechanisms are key controls to prevent the exposure of training data.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      562,
      575,
      482,
      479,
      496
    ],
    "source": "363940_AssessmentTest"
  },
  {
    "id": 33,
    "question": "A financial institution’s fraud detection model begins incorrectly flagging legitimate transactions following a data feed update. What assurance practice would most likely have prevented this?",
    "choice_a": "Periodic retraining using customer feedback",
    "choice_b": "Continuous monitoring with drift detection alerts",
    "choice_c": "Limiting model access to authorized employees only",
    "choice_d": "Increasing the volume of test data",
    "correct_answer": "B",
    "explanation": "Continuous monitoring with statistical drift detection can identify shifts in data distribution or model outputs that could degrade accuracy. Detecting drift early allows organizations to retrain or recalibrate models before significant harm occurs. Continuous monitoring is a key principle of AI assurance and lifecycle governance.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      554,
      578,
      553,
      521,
      453
    ],
    "source": "363940_AssessmentTest"
  },
  {
    "id": 34,
    "question": "An AI-driven hiring platform is being retired due to new legal requirements under the EU AI Act. What is the most critical first step in the deactivation process?",
    "choice_a": "Delete all model artifacts immediately to prevent misuse.",
    "choice_b": "Replace the model with a temporary open-source version.",
    "choice_c": "Notify affected stakeholders and plan for controlled deactivation.",
    "choice_d": "Suspend all employee access without communication.",
    "correct_answer": "C",
    "explanation": "Responsible AI retirement begins with planning and stakeholder communication. Controlled, methodical deactivation ensures that users, partners, and regulators are informed, fallback systems are in place, and audit trails are preserved. Immediate deletion or suspension without planning risks operational disruption and noncompliance.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      616,
      617,
      618,
      608,
      597
    ],
    "source": "363940_AssessmentTest"
  },
  {
    "id": 35,
    "question": "A global company operates an AI translation system that performs differently across languages due to cultural differences. To maintain compliance and effectiveness, which governance strategy is most appropriate?",
    "choice_a": "Implement a single universal model trained on all languages equally.",
    "choice_b": "Disable translations in low-accuracy regions.",
    "choice_c": "Localize and retrain regional models to meet linguistic and cultural requirements.",
    "choice_d": "Outsource compliance entirely to regional vendors.",
    "correct_answer": "C",
    "explanation": "Localization helps AI systems align with regional laws, data residency rules, linguistic nuances, and cultural expectations. Retraining AI models on local data improves fairness, accuracy, and contextual sensitivity. A single, universal AI model may fail to accurately reflect regional linguistic nuances or local regulatory environments.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      464,
      578,
      404,
      555,
      481
    ],
    "source": "363940_AssessmentTest"
  },
  {
    "id": 36,
    "question": "An organization’s AI monitoring system detects a recurring issue that doesn’t meet the threshold for an incident. What is the most appropriate governance response?",
    "choice_a": "Ignore the issue until an incident occurs.",
    "choice_b": "Record it in the issue tracking system for trend analysis and escalation if repeated.",
    "choice_c": "Immediately shut down the affected AI model.",
    "choice_d": "Report it publicly as a compliance event.",
    "correct_answer": "B",
    "explanation": "Higher governance maturity requires capturing lower-severity issues to identify emerging risk patterns. Issue tracking systems enable categorization, assignment, and escalation when trends signal potential degradation or harm. Proactive documentation supports continuous improvement and early risk detection.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      586,
      553,
      554,
      453,
      555
    ],
    "source": "363940_AssessmentTest"
  },
  {
    "id": 37,
    "question": "The Netflix Recommendation Engine and Google Search Autocomplete are examples of:",
    "choice_a": "AI agent",
    "choice_b": "General AI",
    "choice_c": "Narrow AI",
    "choice_d": "Training techniques",
    "correct_answer": "C",
    "explanation": "Narrow AI includes AI systems that perform highly focused tasks. Other examples are spam filters, license plate recognition systems, and Apple Face ID.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      1,
      3,
      2
    ],
    "source": "363940_Ch01"
  },
  {
    "id": 38,
    "question": "An organization has developed an AI system that receives and analyzes input from sensors and takes action as needed. This system is an example of:",
    "choice_a": "AI agent",
    "choice_b": "Robot",
    "choice_c": "General AI",
    "choice_d": "Operational technology",
    "correct_answer": "A",
    "explanation": "An AI agent is a system that receives input from systems and sensors and takes action to achieve specific goals.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      1,
      29,
      2
    ],
    "source": "363940_Ch01"
  },
  {
    "id": 39,
    "question": "An EU-based retail organization retains data about individual transactions and maintains databases with detailed customer information. The organization wants to build an AI system to analyze its customers and transactions, to help better understand sales history and to develop better sales and marketing strategies. What interaction, if any, is required with customers before launching this project?",
    "choice_a": "Customers can opt out of this activity.",
    "choice_b": "Customers must be notified of this activity.",
    "choice_c": "No customer interaction is required.",
    "choice_d": "Customers must explicitly consent to this activity.",
    "correct_answer": "D",
    "explanation": "According to the GDPR, organizations must obtain explicit consent from customers before their information can be used by the AI system for this (or any other) purpose.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      120,
      31,
      147,
      117,
      30
    ],
    "source": "363940_Ch01"
  },
  {
    "id": 40,
    "question": "An IT department is building an AI system and will begin training it with labeled data. What kind of training is this?",
    "choice_a": "Supervised learning",
    "choice_b": "Unsupervised learning",
    "choice_c": "Semi-supervised learning",
    "choice_d": "Reinforcement learning",
    "correct_answer": "A",
    "explanation": "Training an AI system with labeled data is known as supervised learning.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      3
    ],
    "source": "363940_Ch01"
  },
  {
    "id": 41,
    "question": "A regional bank is building an AI system to help analyze loan applications and make approval and interest rate recommendations. What kind of harm must the bank ensure is not realized?",
    "choice_a": "Financial",
    "choice_b": "Social cohesion",
    "choice_c": "Privacy",
    "choice_d": "Bias",
    "correct_answer": "D",
    "explanation": "The type of harm that the bank must watch for is bias, where individuals of certain demographics may be denied loans or favorable loan terms.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      214,
      429,
      259,
      596,
      547
    ],
    "source": "363940_Ch01"
  },
  {
    "id": 42,
    "question": "A regional bank is building an AI system to help analyze loan applications and make approval and interest rate recommendations. What safeguard should the bank implement to ensure fairness?",
    "choice_a": "Event detection",
    "choice_b": "Supervised learning",
    "choice_c": "Human in the loop",
    "choice_d": "Hallucination detection",
    "correct_answer": "C",
    "explanation": "The bank should implement a human in the loop to review loan applications and the AI system’s recommendations to ensure that the AI system is producing correct outputs.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      430,
      259,
      547,
      429,
      214
    ],
    "source": "363940_Ch01"
  },
  {
    "id": 43,
    "question": "A social media platform uses an AI algorithm to select items to appear in users’ data feeds. What potential harm could result if the AI algorithm is biased?",
    "choice_a": "Job displacement",
    "choice_b": "Manipulation of public opinion",
    "choice_c": "Erosion of human autonomy",
    "choice_d": "Privacy",
    "correct_answer": "B",
    "explanation": "A biased AI algorithm in a social media platform could sway public opinion.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      214,
      429,
      564,
      259,
      427
    ],
    "source": "363940_Ch01"
  },
  {
    "id": 44,
    "question": "An organization has implemented a neural network AI system to review job applications and make interview recommendations. An employment candidate recently applied for a position, was rejected by the AI system, and requests an explanation for the rejection. What potential challenge is the organization about to face?",
    "choice_a": "Security incident",
    "choice_b": "Privacy violation",
    "choice_c": "Difficulty in providing a reason for the rejection",
    "choice_d": "Economic inequality",
    "correct_answer": "C",
    "explanation": "Because the organization uses a neural network, known for its opacity and lack of explainability, the organization will have difficulty explaining why the AI system rejected the application.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      430,
      190,
      259,
      587,
      606
    ],
    "source": "363940_Ch01"
  },
  {
    "id": 45,
    "question": "The highest priority in the design of the AI system controlling an autonomous vehicle should be:",
    "choice_a": "Privacy",
    "choice_b": "Safety",
    "choice_c": "Fairness",
    "choice_d": "Security",
    "correct_answer": "B",
    "explanation": "The safety of passengers and others should be the highest priority for an autonomous vehicle.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      427,
      565,
      547,
      546,
      587
    ],
    "source": "363940_Ch01"
  },
  {
    "id": 46,
    "question": "The highest priority in the design of an AI system visually identifying returning customers in a retail store is:",
    "choice_a": "Security",
    "choice_b": "Fairness",
    "choice_c": "Safety",
    "choice_d": "Privacy",
    "correct_answer": "D",
    "explanation": "The design and operation of an AI system employing facial recognition to detect returning customers in a retail store should prioritize privacy above other considerations.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      190,
      215,
      546,
      427,
      587
    ],
    "source": "363940_Ch01"
  },
  {
    "id": 47,
    "question": "Which role is primarily responsible for selecting training data and conducting bias testing during model development?",
    "choice_a": "AI deployer",
    "choice_b": "End user",
    "choice_c": "AI developer",
    "choice_d": "Compliance officer",
    "correct_answer": "C",
    "explanation": "Developers build and train models, which include curating datasets and running fairness evaluations.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      122,
      121,
      39,
      103,
      119
    ],
    "source": "363940_Ch02"
  },
  {
    "id": 48,
    "question": "What is the most appropriate governance structure for a small startup with limited AI resources?",
    "choice_a": "Fully automated audit pipelines",
    "choice_b": "A board-level AI oversight committee",
    "choice_c": "Lightweight governance with designated role champions",
    "choice_d": "Centralized AI governance office with legal authority",
    "correct_answer": "C",
    "explanation": "Startups typically employ simplified governance structures with a few cross-functional leads, due to their limited staff and resources.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      96,
      74,
      60,
      75,
      97
    ],
    "source": "363940_Ch02"
  },
  {
    "id": 49,
    "question": "Which of the following best illustrates cross-functional collaboration in AI governance?",
    "choice_a": "Engineers writing code based on user feedback",
    "choice_b": "A legal team monitoring AI regulatory updates",
    "choice_c": "A data scientist leading all model deployment tasks",
    "choice_d": "An ethics lead, product manager, and ML engineer co-reviewing an AI use case",
    "correct_answer": "D",
    "explanation": "Cross-functional collaboration means multiple departments sharing responsibility for governance decisions.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      74,
      75,
      105,
      63,
      62
    ],
    "source": "363940_Ch02"
  },
  {
    "id": 50,
    "question": "Why is it important to tailor AI governance training to different stakeholder roles?",
    "choice_a": "Because only technical staff require training",
    "choice_b": "To increase automation in governance processes",
    "choice_c": "Because each role interacts with AI differently and needs context-specific knowledge",
    "choice_d": "To reduce the number of governance roles",
    "correct_answer": "C",
    "explanation": "Training must reflect how stakeholders utilize AI to be relevant and effective.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      87,
      88,
      104,
      103,
      62
    ],
    "source": "363940_Ch02"
  },
  {
    "id": 51,
    "question": "What distinguishes an AI user from a developer or deployer in governance terms?",
    "choice_a": "Users monitor system drift",
    "choice_b": "Users design model architectures",
    "choice_c": "Users interact with the AI in real-world scenarios and may flag harm",
    "choice_d": "Users control the data pipeline",
    "correct_answer": "C",
    "explanation": "Users are closest to the operational impact of AI and are often the first to detect unintended outcomes.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      103,
      104,
      62,
      123,
      63
    ],
    "source": "363940_Ch02"
  },
  {
    "id": 52,
    "question": "Which governance strategy is most appropriate for a highly regulated industry like healthcare?",
    "choice_a": "Informal team agreements",
    "choice_b": "Lightweight ethics principles",
    "choice_c": "Formal reviews, documentation, and auditability",
    "choice_d": "No oversight beyond the product team",
    "correct_answer": "C",
    "explanation": "Regulated industries require strict controls, impact assessments, and compliance documentation.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      98,
      124,
      75,
      117,
      61
    ],
    "source": "363940_Ch02"
  },
  {
    "id": 53,
    "question": "In a RACI matrix, what does the “A” stand for?",
    "choice_a": "Analyzed",
    "choice_b": "Accountable",
    "choice_c": "Audited",
    "choice_d": "Authorized",
    "correct_answer": "B",
    "explanation": "“Accountable” means the person who ultimately owns the task or process and ensures it’s completed correctly.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      63,
      74,
      60,
      61,
      62
    ],
    "source": "363940_Ch02"
  },
  {
    "id": 54,
    "question": "Which of the following is a governance responsibility specific to AI deployers?",
    "choice_a": "Performing legal impact assessments",
    "choice_b": "Conducting data annotation",
    "choice_c": "Integrating models into production and setting up monitoring",
    "choice_d": "Filing incident reports with regulators",
    "correct_answer": "C",
    "explanation": "Deployers operationalize models, ensuring they function reliably and are monitored for risk.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      103,
      104,
      123,
      63,
      105
    ],
    "source": "363940_Ch02"
  },
  {
    "id": 55,
    "question": "What is a primary governance benefit of cross-functional AI use case reviews?",
    "choice_a": "Increased software development speed",
    "choice_b": "Reduced need for end-user input",
    "choice_c": "Holistic risk evaluation from multiple perspectives",
    "choice_d": "Avoiding documentation of model design",
    "correct_answer": "C",
    "explanation": "Collaborative reviews ensure that ethical, legal, business, and technical risks are considered together.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      74,
      75,
      62,
      105,
      118
    ],
    "source": "363940_Ch02"
  },
  {
    "id": 56,
    "question": "Which of the following would most likely appear in a well-designed AI governance training program?",
    "choice_a": "A primer on generative art",
    "choice_b": "A tutorial on coding best practices",
    "choice_c": "A case study showing governance failure and mitigation",
    "choice_d": "A financial literacy quiz",
    "correct_answer": "C",
    "explanation": "Real-world examples help stakeholders understand the consequences of poor governance and how to respond.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      87,
      88,
      89,
      76,
      75
    ],
    "source": "363940_Ch02"
  },
  {
    "id": 57,
    "question": "Which of the following best describes a key principle of lifecycle-based AI governance?",
    "choice_a": "Apply oversight only at the deployment stage",
    "choice_b": "Delegate AI governance solely to the data science team",
    "choice_c": "Embed accountability mechanisms at each phase of the AI development process",
    "choice_d": "Use governance only for models trained on sensitive data",
    "correct_answer": "C",
    "explanation": "AI governance must be continuous and span the entire lifecycle, from use case assessment to incident management. Limiting governance to deployment or specific data types introduces risk.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      117,
      63,
      118,
      119,
      60
    ],
    "source": "363940_Ch03"
  },
  {
    "id": 58,
    "question": "What is the primary risk associated with using anonymized training data in AI models?",
    "choice_a": "The data cannot be used under GDPR.",
    "choice_b": "Anonymized data increases training time.",
    "choice_c": "AI models can potentially reidentify individuals through inference.",
    "choice_d": "Anonymized data always improves model fairness.",
    "correct_answer": "C",
    "explanation": "Even anonymized data can be reverse-engineered or inferred from model behavior. This is a known risk in AI privacy and requires stronger safeguards.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      146,
      120,
      147,
      6,
      40
    ],
    "source": "363940_Ch03"
  },
  {
    "id": 59,
    "question": "Which of the following is a valid policy control for managing third-party AI risk?",
    "choice_a": "Relying on vendor self-attestations without further review",
    "choice_b": "Requiring model documentation and training data provenance",
    "choice_c": "Limiting partnerships to vendors with ISO 42001 certification only",
    "choice_d": "Prohibiting all third-party AI tools entirely",
    "correct_answer": "B",
    "explanation": "Governance policies should demand transparency about the model and data. Documentation helps evaluate fairness, legality, and risk exposure.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      120,
      159,
      124,
      157,
      158
    ],
    "source": "363940_Ch03"
  },
  {
    "id": 60,
    "question": "A policy that mandates periodic monitoring for model drift is best aligned with which lifecycle stage?",
    "choice_a": "Data acquisition",
    "choice_b": "Deployment and monitoring",
    "choice_c": "Training and testing",
    "choice_d": "Use case approval",
    "correct_answer": "B",
    "explanation": "Monitoring is a post-deployment function that ensures models continue to perform ethically and effectively under real-world conditions, for example, to detect emerging bias and drift issues.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      123,
      63,
      117,
      104,
      161
    ],
    "source": "363940_Ch03"
  },
  {
    "id": 61,
    "question": "Which of the following is a recommended contractual clause when procuring an AI-enabled service?",
    "choice_a": "The vendor must disclose all proprietary source code.",
    "choice_b": "The vendor is exempt from bias-related complaints.",
    "choice_c": "The vendor must allow audit access and disclose data sources.",
    "choice_d": "The vendor will maintain confidentiality for three months only.",
    "correct_answer": "C",
    "explanation": "Contracts should require transparency and auditability, especially for high-risk AI applications. This includes data origin, fairness testing, and monitoring results.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      159,
      158,
      157,
      120,
      124
    ],
    "source": "363940_Ch03"
  },
  {
    "id": 62,
    "question": "What is one reason traditional privacy policies may be insufficient for AI systems?",
    "choice_a": "They do not address the retention of inference outputs.",
    "choice_b": "They assume all data is structured.",
    "choice_c": "They focus only on system availability.",
    "choice_d": "They prohibit all personal data processing.",
    "correct_answer": "A",
    "explanation": "AI models may “remember” or leak training data. Traditional policies rarely account for the retention risks related to what a model has learned or memorized.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      146,
      147,
      120,
      40,
      30
    ],
    "source": "363940_Ch03"
  },
  {
    "id": 63,
    "question": "What is the purpose of assigning risk tiers to AI vendors?",
    "choice_a": "To limit the number of contracts issued",
    "choice_b": "To determine marketing budgets for the AI solution",
    "choice_c": "To apply appropriate governance controls based on risk level",
    "choice_d": "To allow procurement to bypass risk reviews for large vendors",
    "correct_answer": "C",
    "explanation": "Risk-based tiering ensures that higher-risk vendors (for example, those processing sensitive data or supporting critical functions) are subject to more thorough review and oversight.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      158,
      99,
      159,
      161,
      157
    ],
    "source": "363940_Ch03"
  },
  {
    "id": 64,
    "question": "Which policy control helps enforce purpose limitation in AI pipelines?",
    "choice_a": "Allowing unlimited data reuse for internal projects",
    "choice_b": "Using a use case registry to tag approved applications of data",
    "choice_c": "Prohibiting the use of cloud storage",
    "choice_d": "Allowing only unstructured data in training",
    "correct_answer": "B",
    "explanation": "A use case registry enables organizations to track and enforce approved purposes for data use, preventing unauthorized repurposing.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      147,
      117,
      75,
      120,
      118
    ],
    "source": "363940_Ch03"
  },
  {
    "id": 65,
    "question": "Which of the following would most effectively reduce bias in AI model development?",
    "choice_a": "Encrypting all datasets before training",
    "choice_b": "Testing model outputs against diverse population subgroups",
    "choice_c": "Using only synthetic data in training",
    "choice_d": "Optimizing models solely for accuracy",
    "correct_answer": "B",
    "explanation": "Fairness testing against different groups helps identify and reduce disparate impact, which is essential for ethical AI development.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      122,
      39,
      119,
      6,
      118
    ],
    "source": "363940_Ch03"
  },
  {
    "id": 66,
    "question": "What does “model inversion” refer to in the context of AI privacy risk?",
    "choice_a": "Reversing a model’s optimization objective",
    "choice_b": "Recovering training data from model outputs",
    "choice_c": "Changing labels after training is complete",
    "choice_d": "A method of retraining a model on augmented data",
    "correct_answer": "B",
    "explanation": "Model inversion is a privacy threat in which attackers use access to a model to reconstruct inputs from its outputs, posing serious risks to data confidentiality.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      146,
      120,
      40,
      6,
      30
    ],
    "source": "363940_Ch03"
  },
  {
    "id": 67,
    "question": "Under the GDPR, which legal basis is most often required for processing special category (sensitive) data?",
    "choice_a": "Explicit consent",
    "choice_b": "Performance of a contract",
    "choice_c": "Legitimate consent",
    "choice_d": "Implied consent",
    "correct_answer": "A",
    "explanation": "Article 9 of the GDPR generally prohibits the processing of special category data unless an exception applies; the most common exception is explicit consent, which must be freely given, specific, and informed.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      212,
      207,
      172,
      216,
      208
    ],
    "source": "363940_Ch04"
  },
  {
    "id": 68,
    "question": "Which of the following best describes purpose limitation in the context of AI?",
    "choice_a": "Collecting data from as many sources as possible",
    "choice_b": "Allowing reuse of data for any purpose deemed profitable",
    "choice_c": "Ensuring data is collected for a specific, explicit purpose and not reused incompatibly",
    "choice_d": "Using third-party datasets without reviewing their original purpose",
    "correct_answer": "C",
    "explanation": "Purpose limitation requires that personal data be used only for the purpose for which it was collected, and not repurposed unless the new use is compatible or consent is reobtained.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      173,
      172,
      181,
      177,
      216
    ],
    "source": "363940_Ch04"
  },
  {
    "id": 69,
    "question": "A Data Protection Impact Assessment (DPIA) is required when:",
    "choice_a": "Any data is used for marketing",
    "choice_b": "A low-risk AI system is deployed",
    "choice_c": "A system is used internally by employees only",
    "choice_d": "Processing involves special category data and could pose high risks to rights and freedoms",
    "correct_answer": "D",
    "explanation": "DPIAs are mandated under Article 35 of the GDPR when processing is likely to result in a high risk to individuals, including when AI systems process sensitive data.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      187,
      207,
      216,
      177,
      181
    ],
    "source": "363940_Ch04"
  },
  {
    "id": 70,
    "question": "What role does a data controller play in the AI lifecycle?",
    "choice_a": "Manages the physical server infrastructure",
    "choice_b": "Develops algorithms for all third parties",
    "choice_c": "Determines the purpose and means of data processing",
    "choice_d": "Handles data breaches only",
    "correct_answer": "C",
    "explanation": "A data controller is responsible for deciding why and how personal data is processed and carries the accountability for compliance with data protection laws.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      188,
      181,
      192,
      187,
      173
    ],
    "source": "363940_Ch04"
  },
  {
    "id": 71,
    "question": "Which of the following would likely require heightened safeguards under privacy law?",
    "choice_a": "User preferences on website themes",
    "choice_b": "Facial recognition used for retail surveillance",
    "choice_c": "Email addresses used for newsletter signups",
    "choice_d": "A/B testing of homepage layout",
    "correct_answer": "B",
    "explanation": "Facial recognition is a form of biometric data used for identification, which qualifies as special category data and requires strict controls under laws such as the GDPR.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      208,
      207,
      212,
      216,
      217
    ],
    "source": "363940_Ch04"
  },
  {
    "id": 72,
    "question": "What is a common risk of AI systems inferring sensitive data?",
    "choice_a": "Low training cost",
    "choice_b": "Reduced model explainability",
    "choice_c": "Triggering legal obligations even if the data was not explicitly collected",
    "choice_d": "Inference accuracy cannot be evaluated",
    "correct_answer": "C",
    "explanation": "When AI systems infer special category attributes (for example, religion, sexual orientation), this processing is still subject to the same legal protections and may require consent or an Article 9 exception.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      208,
      212,
      207,
      172,
      216
    ],
    "source": "363940_Ch04"
  },
  {
    "id": 73,
    "question": "What is a key element of privacy by design in AI systems?",
    "choice_a": "Prioritizing model accuracy over user privacy",
    "choice_b": "Embedding privacy protections throughout the system lifecycle",
    "choice_c": "Outsourcing compliance to vendors",
    "choice_d": "Avoiding DPIAs unless requested by a regulator",
    "correct_answer": "B",
    "explanation": "Privacy by design calls for integrating privacy considerations at every stage of development, from problem definition to deployment and monitoring.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      177,
      181,
      178,
      182,
      192
    ],
    "source": "363940_Ch04"
  },
  {
    "id": 74,
    "question": "Which scenario best reflects the principle of data minimization?",
    "choice_a": "Collecting all available user data for future analysis",
    "choice_b": "Using anonymized transaction data limited to the current model’s purpose",
    "choice_c": "Archiving full user profiles for at least ten years",
    "choice_d": "Combining datasets from unrelated apps to improve personalization",
    "correct_answer": "B",
    "explanation": "Data minimization refers to collecting and using only the information necessary for a specific task. Anonymized, purpose-limited data use is a textbook example.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      176,
      173,
      181,
      177,
      187
    ],
    "source": "363940_Ch04"
  },
  {
    "id": 75,
    "question": "Which obligation must a controller meet when using third-party AI processors?",
    "choice_a": "Sign a DPA with required contractual terms under Article 28 GDPR",
    "choice_b": "Include model logic in the user privacy notice",
    "choice_c": "Allow unlimited use of training data by the vendor",
    "choice_d": "Accept vendor liability for privacy compliance",
    "correct_answer": "A",
    "explanation": "Controllers must have contracts with processors that define the scope, safeguards, instructions, and responsibilities as outlined in Article 28 of the GDPR.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      188,
      181,
      192,
      178,
      187
    ],
    "source": "363940_Ch04"
  },
  {
    "id": 76,
    "question": "Under GDPR Article 22, what must be provided when a decision based solely on automated processing significantly affects an individual?",
    "choice_a": "Access to the source code",
    "choice_b": "Unlimited data portability",
    "choice_c": "Meaningful human review and an option to contest the decision",
    "choice_d": "Permanent deletion of the data",
    "correct_answer": "C",
    "explanation": "Article 22 of the GDPR requires that individuals subject to significant automated decisions have the right to obtain human intervention, express their point of view, and contest the outcome.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      217,
      210,
      216,
      317,
      316
    ],
    "source": "363940_Ch04"
  },
  {
    "id": 77,
    "question": "Which of the following best describes a potential copyright issue with AI training data?",
    "choice_a": "Using data from government websites",
    "choice_b": "Training on public domain materials",
    "choice_c": "Using copyrighted images without permission",
    "choice_d": "Using statistical summaries of datasets",
    "correct_answer": "C",
    "explanation": "Using copyrighted images without permission may infringe on reproduction rights and does not automatically qualify as fair use.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      233,
      231,
      234,
      237,
      238
    ],
    "source": "363940_Ch05"
  },
  {
    "id": 78,
    "question": "Under U.S. law, which of the following is a protected characteristic in employment discrimination cases involving AI tools?",
    "choice_a": "Internet usage history",
    "choice_b": "Political affiliation",
    "choice_c": "Education level",
    "choice_d": "Race",
    "correct_answer": "D",
    "explanation": "Race is explicitly protected under Title VII of the Civil Rights Act. AI tools must be audited for disparate impact across such categories.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      255,
      254,
      211
    ],
    "source": "363940_Ch05"
  },
  {
    "id": 79,
    "question": "What is a key principle behind the FTC’s approach to AI under Section 5 of the FTC Act?",
    "choice_a": "AI is not subject to consumer protection laws",
    "choice_b": "Only AI used for profit is regulated",
    "choice_c": "Undisclosed use of AI may be considered deceptive",
    "choice_d": "AI disclosures must be approved by a federal judge",
    "correct_answer": "C",
    "explanation": "The FTC has warned that failing to disclose AI interactions may mislead reasonable consumers and violate deceptive practice standards.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      275,
      276,
      274,
      297,
      318
    ],
    "source": "363940_Ch05"
  },
  {
    "id": 80,
    "question": "In product liability law, what type of defect occurs when a product’s original design is inherently unsafe?",
    "choice_a": "Marketing defect",
    "choice_b": "Manufacturing defect",
    "choice_c": "Design defect",
    "choice_d": "Distribution defect",
    "correct_answer": "C",
    "explanation": "Design defects refer to flaws in the product’s intended specifications, regardless of how well it was manufactured.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      294,
      295,
      297
    ],
    "source": "363940_Ch05"
  },
  {
    "id": 81,
    "question": "Which legal framework prohibits discrimination in loan decisions made by AI?",
    "choice_a": "Computer Fraud and Abuse Act (CFAA)",
    "choice_b": "Equal Credit Opportunity Act (ECOA)",
    "choice_c": "Digital Millennium Copyright Act (DMCA)",
    "choice_d": "Sherman Antitrust Act",
    "correct_answer": "B",
    "explanation": "ECOA bars discriminatory loan and credit practices and applies to both human and algorithmic decision-making processes.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      256,
      254,
      274,
      257,
      255
    ],
    "source": "363940_Ch05"
  },
  {
    "id": 82,
    "question": "A chatbot giving unlicensed medical advice without disclosure most likely violates which type of law?",
    "choice_a": "Trade secret law",
    "choice_b": "Employment law",
    "choice_c": "Consumer protection law",
    "choice_d": "Patent law",
    "correct_answer": "C",
    "explanation": "Providing health advice without disclaimers or licenses can mislead consumers and trigger enforcement under UDAP (unfair, deceptive, or abusive practices) laws.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      274,
      276,
      275,
      277,
      209
    ],
    "source": "363940_Ch05"
  },
  {
    "id": 83,
    "question": "Which of the following is not typically a valid defense against a product liability claim involving AI?",
    "choice_a": "The AI was too complex to predict",
    "choice_b": "The product was used as intended",
    "choice_c": "A safer design was available",
    "choice_d": "The product caused foreseeable harm",
    "correct_answer": "A",
    "explanation": "Complexity is not a valid defense. Manufacturers are still responsible for designing reasonably safe products.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      294,
      295,
      297,
      299,
      296
    ],
    "source": "363940_Ch05"
  },
  {
    "id": 84,
    "question": "Which regulatory body issued guidance clarifying employer obligations when using AI tools in hiring?",
    "choice_a": "Federal Reserve",
    "choice_b": "National Labor Relations Board",
    "choice_c": "Equal Employment Opportunity Commission (EEOC)",
    "choice_d": "U.S. Copyright Office",
    "correct_answer": "C",
    "explanation": "The EEOC has explicitly stated that employers are responsible for ensuring that AI hiring tools do not discriminate.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      255,
      275,
      257
    ],
    "source": "363940_Ch05"
  },
  {
    "id": 85,
    "question": "What is a key risk of using proxy variables in AI decision-making?",
    "choice_a": "They may have a disparate impact on protected groups",
    "choice_b": "They can be more efficient than direct attributes",
    "choice_c": "They reduce model complexity",
    "choice_d": "They are required by most civil rights laws",
    "correct_answer": "A",
    "explanation": "Proxy variables (like postal code) can correlate with race or income, potentially causing discriminatory outcomes.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      214,
      429,
      259,
      564,
      430
    ],
    "source": "363940_Ch05"
  },
  {
    "id": 86,
    "question": "Which of the following best describes the FTC’s stance on AI performance claims?",
    "choice_a": "They are allowed as long as results are plausible",
    "choice_b": "They require substantiation like any other product claim",
    "choice_c": "They are exempt from scrutiny if the AI is open source",
    "choice_d": "They must be approved by a third-party certifier",
    "correct_answer": "B",
    "explanation": "AI performance claims must be supported by evidence and testing—just like any other advertising or product representation.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      275,
      274,
      276,
      352,
      192
    ],
    "source": "363940_Ch05"
  },
  {
    "id": 87,
    "question": "Under the EU AI Act, which of the following is considered a prohibited AI practice?",
    "choice_a": "AI used in autonomous vehicles",
    "choice_b": "AI used in spam filtering",
    "choice_c": "Real-time biometric identification in public spaces (without exceptions)",
    "choice_d": "AI used in personalized shopping recommendations",
    "correct_answer": "C",
    "explanation": "The EU AI Act bans real-time biometric identification in public spaces unless specific public safety exceptions apply. This practice is considered unacceptably risky.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      311,
      208,
      316,
      337,
      343
    ],
    "source": "363940_Ch06"
  },
  {
    "id": 88,
    "question": "What is the key documentation requirement for high-risk AI systems under the EU AI Act?",
    "choice_a": "Patent registration",
    "choice_b": "Social impact assessment",
    "choice_c": "Technical documentation covering design, risk, and oversight",
    "choice_d": "Environmental footprint report",
    "correct_answer": "C",
    "explanation": "High-risk AI systems must include detailed technical documentation that supports transparency, traceability, and accountability.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      316,
      317,
      311,
      192,
      216
    ],
    "source": "363940_Ch06"
  },
  {
    "id": 89,
    "question": "Which type of organization is responsible for placing an AI system on the EU market under its own name?",
    "choice_a": "Importer",
    "choice_b": "Deployer",
    "choice_c": "Distributor",
    "choice_d": "Provider",
    "correct_answer": "D",
    "explanation": "A provider develops and markets the AI system under its own name and is responsible for ensuring compliance.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      337,
      322,
      338,
      317,
      311
    ],
    "source": "363940_Ch06"
  },
  {
    "id": 90,
    "question": "What is a key obligation for deployers of high-risk AI systems?",
    "choice_a": "CE marking",
    "choice_b": "Human oversight during use",
    "choice_c": "Notifying customs authorities",
    "choice_d": "Conducting environmental testing",
    "correct_answer": "B",
    "explanation": "Deployers must ensure human oversight during operation to support safety and mitigate unintended consequences.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      317,
      337,
      316,
      311,
      216
    ],
    "source": "363940_Ch06"
  },
  {
    "id": 91,
    "question": "Which of the following AI system categories is mostly exempt from mandatory regulation?",
    "choice_a": "GPAI with systemic risk",
    "choice_b": "Minimal-risk AI",
    "choice_c": "High-risk AI",
    "choice_d": "Limited-risk AI",
    "correct_answer": "B",
    "explanation": "Minimal-risk AI systems, like grammar checkers and spam filters, are largely unregulated under the EU AI Act.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      312,
      318,
      311,
      317,
      337
    ],
    "source": "363940_Ch06"
  },
  {
    "id": 92,
    "question": "What triggers enhanced requirements for a GPAI system?",
    "choice_a": "Use of open-source code",
    "choice_b": "Use in a single domain",
    "choice_c": "Systemic risk designation",
    "choice_d": "Training with European data",
    "correct_answer": "C",
    "explanation": "GPAI systems deemed to pose systemic risk, due to scale or influence, face stricter obligations such as external audits and real-time monitoring.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      323,
      322,
      343,
      311,
      317
    ],
    "source": "363940_Ch06"
  },
  {
    "id": 93,
    "question": "Importers of AI systems must ensure that the system:",
    "choice_a": "Includes a software license",
    "choice_b": "Is CE marked and has passed conformity assessment",
    "choice_c": "Is developed in an EU member state",
    "choice_d": "Contains only anonymized data",
    "correct_answer": "B",
    "explanation": "Importers are responsible for verifying that the AI system complies with EU conformity standards, including CE marking.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      338,
      317,
      311,
      332,
      333
    ],
    "source": "363940_Ch06"
  },
  {
    "id": 94,
    "question": "What is the maximum financial penalty for prohibited AI practices?",
    "choice_a": "€1 million",
    "choice_b": "€7.5 million",
    "choice_c": "€15 million",
    "choice_d": "€35 million or 7 % of global turnover",
    "correct_answer": "D",
    "explanation": "The most serious violations, such as using prohibited AI, can incur penalties of up to €35 million or 7 percent of global revenue, whichever is greater.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      333,
      311,
      275,
      182,
      312
    ],
    "source": "363940_Ch06"
  },
  {
    "id": 95,
    "question": "A distributor becomes legally liable under the EU AI Act if they:",
    "choice_a": "Use AI internally",
    "choice_b": "Manufacture hardware for AI use",
    "choice_c": "Ignore known signs of non-compliance",
    "choice_d": "Provide AI training datasets",
    "correct_answer": "C",
    "explanation": "Distributors must act if they become aware of non-compliance; failing to do so triggers liability.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      338,
      332,
      333,
      323,
      298
    ],
    "source": "363940_Ch06"
  },
  {
    "id": 96,
    "question": "What is the purpose of a “model card” in the context of GPAI?",
    "choice_a": "It describes the hardware compatibility of the system",
    "choice_b": "It registers the system with the European Patent Office",
    "choice_c": "It summarizes technical specifications and known limitations",
    "choice_d": "It licenses the model for public use",
    "correct_answer": "C",
    "explanation": "A model card is a transparency tool that describes an AI model’s design, training data, capabilities, and risks to inform responsible downstream use.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      192,
      322,
      352,
      316,
      178
    ],
    "source": "363940_Ch06"
  },
  {
    "id": 97,
    "question": "What is the primary purpose of the OECD AI Principles?",
    "choice_a": "To create mandatory AI regulations for OECD countries",
    "choice_b": "To define technical testing protocols for AI safety",
    "choice_c": "To establish ethical guidelines for trustworthy AI",
    "choice_d": "To categorize AI systems by risk level",
    "correct_answer": "C",
    "explanation": "The OECD AI Principles offer non-binding ethical guidelines designed to foster responsible, human-centered AI across member countries. They focus on values like transparency, fairness, and accountability.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      345,
      395,
      394,
      349,
      381
    ],
    "source": "363940_Ch07"
  },
  {
    "id": 98,
    "question": "Which NIST AI RMF function is responsible for identifying the context and intended purpose of an AI system?",
    "choice_a": "Manage",
    "choice_b": "Measure",
    "choice_c": "Map",
    "choice_d": "Govern",
    "correct_answer": "C",
    "explanation": "The Map function focuses on understanding the AI system’s design, context of use, stakeholder impacts, and associated risks.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      351,
      349,
      354,
      350,
      352
    ],
    "source": "363940_Ch07"
  },
  {
    "id": 99,
    "question": "What distinguishes NIST ARIA from the NIST AI RMF?",
    "choice_a": "ARIA addresses regulatory compliance, while RMF does not",
    "choice_b": "ARIA focuses on assurance methods and testing techniques",
    "choice_c": "ARIA is a certification framework",
    "choice_d": "ARIA replaces the RMF in high-risk sectors",
    "correct_answer": "B",
    "explanation": "NIST ARIA complements the AI RMF by providing practical tools, metrics, and methodologies to test and evaluate AI systems for safety and trustworthiness.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      374,
      352,
      375,
      349,
      354
    ],
    "source": "363940_Ch07"
  },
  {
    "id": 100,
    "question": "What is a defining feature of ISO/IEC 42001?",
    "choice_a": "It is a privacy-focused AI framework",
    "choice_b": "It standardizes AI ethics assessments",
    "choice_c": "It offers a certifiable AI management system",
    "choice_d": "It provides a taxonomy of AI capabilities",
    "correct_answer": "C",
    "explanation": "ISO/IEC 42001 is the first AI-specific management system standard that organizations can certify against, similar to ISO/IEC 27001 for information security management.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      382,
      383,
      384,
      381,
      395
    ],
    "source": "363940_Ch07"
  },
  {
    "id": 101,
    "question": "What is the purpose of ISO/IEC 22989?",
    "choice_a": "To regulate foundation models",
    "choice_b": "To define global AI enforcement mechanisms",
    "choice_c": "To standardize AI terminology and concepts",
    "choice_d": "To guide AI procurement strategies",
    "correct_answer": "C",
    "explanation": "ISO/IEC 22989 offers foundational definitions for AI systems, capabilities, and lifecycle stages, facilitating consistency across industries.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      381,
      384,
      395,
      382,
      349
    ],
    "source": "363940_Ch07"
  },
  {
    "id": 102,
    "question": "Which G7 initiative provides guidance on AI governance?",
    "choice_a": "Hiroshima Process",
    "choice_b": "Kyoto Protocol",
    "choice_c": "Tokyo AI Alignment Act",
    "choice_d": "OECD Code of Conduct",
    "correct_answer": "A",
    "explanation": "The G7 Hiroshima Process includes a voluntary code of conduct aimed at developers of AI and foundation models to promote responsible innovation.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      394,
      395,
      345,
      349,
      354
    ],
    "source": "363940_Ch07"
  },
  {
    "id": 103,
    "question": "The IEEE 7000 series focuses on which aspect of AI systems?",
    "choice_a": "Model compression and optimization",
    "choice_b": "Ethical alignment during system design",
    "choice_c": "High-frequency trading algorithms",
    "choice_d": "National security applications of AI",
    "correct_answer": "B",
    "explanation": "The IEEE 7000 series supports embedding ethical considerations directly into AI system design and engineering processes.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      394,
      382,
      172,
      177,
      351
    ],
    "source": "363940_Ch07"
  },
  {
    "id": 104,
    "question": "Which of the following is a key trustworthiness characteristic emphasized by NIST ARIA?",
    "choice_a": "Profitability",
    "choice_b": "Interpretability",
    "choice_c": "Processing speed",
    "choice_d": "Licensing model",
    "correct_answer": "B",
    "explanation": "NIST ARIA supports measurement and assurance techniques for trustworthiness traits, including interpretability, robustness, and fairness.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      374,
      349,
      352,
      345,
      381
    ],
    "source": "363940_Ch07"
  },
  {
    "id": 105,
    "question": "What distinguishes ISO/IEC 23894 from ISO/IEC 42001?",
    "choice_a": "23894 is focused on risk management, while 42001 is a management system",
    "choice_b": "23894 defines training standards for AI teams",
    "choice_c": "23894 only applies to AI in manufacturing",
    "choice_d": "23894 provides legal enforcement guidance",
    "correct_answer": "A",
    "explanation": "ISO/IEC 23894 provides detailed guidance on AI risk management processes, while ISO/IEC 42001 defines a complete management system for AI.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      384,
      382,
      381,
      349,
      354
    ],
    "source": "363940_Ch07"
  },
  {
    "id": 106,
    "question": "Why is UNESCO’s AI recommendation particularly influential in the global south?",
    "choice_a": "It provides hardware specifications for AI systems",
    "choice_b": "It offers a prescriptive legal framework",
    "choice_c": "It aligns with principles of cultural inclusion and human rights",
    "choice_d": "It enforces AI bans on specific use cases",
    "correct_answer": "C",
    "explanation": "UNESCO’s recommendation focuses on equity, sustainability, and cultural diversity, making it a practical and values-driven resource in countries without detailed AI regulations.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      395,
      394,
      384,
      349,
      345
    ],
    "source": "363940_Ch07"
  },
  {
    "id": 107,
    "question": "What is the primary purpose of documenting the AI system lifecycle?",
    "choice_a": "To accelerate deployment timelines",
    "choice_b": "To reduce storage costs",
    "choice_c": "To enable traceability and support governance",
    "choice_d": "To comply with open-source licensing requirements",
    "correct_answer": "C",
    "explanation": "Lifecycle documentation supports traceability, governance, and audit readiness, especially when evaluating compliance, fairness, or model behavior over time.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      405,
      579,
      403,
      498,
      578
    ],
    "source": "363940_Ch08"
  },
  {
    "id": 108,
    "question": "Which factor is most important when defining the business context for an AI system?",
    "choice_a": "The organizational objective(s) the system supports",
    "choice_b": "The number of employees on the data team",
    "choice_c": "The vendor’s market share",
    "choice_d": "Whether the system uses neural networks",
    "correct_answer": "A",
    "explanation": "AI systems should be aligned with business objectives to ensure they serve real-world needs and deliver measurable value.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      428,
      427,
      431,
      564,
      547
    ],
    "source": "363940_Ch08"
  },
  {
    "id": 109,
    "question": "An AI impact assessment should be conducted primarily to:",
    "choice_a": "Document proprietary model architectures for publication",
    "choice_b": "Increase investor visibility",
    "choice_c": "Certify the model for ISO 27001",
    "choice_d": "Identify and mitigate risks associated with AI system use",
    "correct_answer": "D",
    "explanation": "Impact assessments help surface potential harms, compliance gaps, and ethical issues early in the development process. The EU AI Act requires impact assessments for high-risk AI systems.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      427,
      429,
      430,
      564,
      565
    ],
    "source": "363940_Ch08"
  },
  {
    "id": 110,
    "question": "What is a typical reason for integrating human-in-the-loop (HITL) mechanisms into AI design?",
    "choice_a": "To speed up model inference",
    "choice_b": "To eliminate the need for documentation",
    "choice_c": "To allow for human oversight and intervention in critical decisions",
    "choice_d": "To reduce power consumption",
    "correct_answer": "C",
    "explanation": "HITL ensures that humans can review, override, or validate AI decisions in high-stakes scenarios, increasing organizational accountability and safety.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      443,
      555,
      417,
      444,
      508
    ],
    "source": "363940_Ch08"
  },
  {
    "id": 111,
    "question": "Which of the following is a disadvantage of developing a proprietary AI model?",
    "choice_a": "Increased liability and regulatory obligations",
    "choice_b": "Reduced system accuracy",
    "choice_c": "Increased dependency on open-source data",
    "choice_d": "Inability to access APIs",
    "correct_answer": "A",
    "explanation": "Developing proprietary models gives organizations more control, but also increases exposure to legal, regulatory, and ethical responsibilities.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      463,
      536,
      404,
      578,
      464
    ],
    "source": "363940_Ch08"
  },
  {
    "id": 112,
    "question": "What does a probability/severity matrix help teams accomplish during design risk assessments?",
    "choice_a": "Optimize GPU usage",
    "choice_b": "Score and prioritize potential risks",
    "choice_c": "Determine intellectual property value",
    "choice_d": "Choose a programming language",
    "correct_answer": "B",
    "explanation": "A probability/severity matrix helps quantify and prioritize risks based on their likelihood and potential impact.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      450,
      562,
      449,
      536,
      453
    ],
    "source": "363940_Ch08"
  },
  {
    "id": 113,
    "question": "Which of the following best supports explainability in AI systems?",
    "choice_a": "Obfuscation of model weights",
    "choice_b": "Publishing training code without documentation",
    "choice_c": "Feature importance scoring and user-facing explanations",
    "choice_d": "Encrypting data pipelines",
    "correct_answer": "C",
    "explanation": "Feature importance metrics and clear, contextual explanations enhance understanding for users and stakeholders.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      430,
      259,
      190,
      608,
      548
    ],
    "source": "363940_Ch08"
  },
  {
    "id": 114,
    "question": "Why is stakeholder mapping critical during risk identification?",
    "choice_a": "It replaces the need for testing",
    "choice_b": "It ensures that all server endpoints are documented",
    "choice_c": "It helps classify model types by algorithm",
    "choice_d": "It identifies how different groups perceive and are affected by AI system risks",
    "correct_answer": "D",
    "explanation": "Stakeholder mapping reveals who is impacted, what their concerns are, and how risks differ across roles and perspectives.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      429,
      427,
      564,
      565,
      548
    ],
    "source": "363940_Ch08"
  },
  {
    "id": 115,
    "question": "Which of the following would best demonstrate readiness to deploy a proprietary AI model?",
    "choice_a": "Having a high-performing model with no documented metrics",
    "choice_b": "Completing shadow mode testing with documented outcomes",
    "choice_c": "Outsourcing testing to a third-party without internal review",
    "choice_d": "Publishing a press release",
    "correct_answer": "B",
    "explanation": "Shadow mode testing simulates real-world conditions without affecting users, enabling risk detection and performance validation. Shadow mode testing is similar to parallel testing in IT disaster recovery planning.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      596,
      616,
      563,
      608,
      278
    ],
    "source": "363940_Ch08"
  },
  {
    "id": 116,
    "question": "Under the EU AI Act, a company that develops and deploys its own AI model is considered which of the following?",
    "choice_a": "Consumer",
    "choice_b": "Deployer",
    "choice_c": "Provider",
    "choice_d": "Tester",
    "correct_answer": "C",
    "explanation": "A company that develops and deploys its own AI system is legally classified as a “provider,” carrying additional obligations under the EU AI Act.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      463,
      578,
      536,
      464,
      403
    ],
    "source": "363940_Ch08"
  },
  {
    "id": 117,
    "question": "What is the primary purpose of data governance in AI development?",
    "choice_a": "To improve marketing performance",
    "choice_b": "To reduce software development costs",
    "choice_c": "To ensure lawful, high-quality, and appropriate data use",
    "choice_d": "To eliminate the need for human review",
    "correct_answer": "C",
    "explanation": "Data governance ensures that data is lawfully collected, accurate, sufficient, and suitable for its intended AI use, forming the foundation of trustworthy system development.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      479,
      480,
      416,
      482,
      481
    ],
    "source": "363940_Ch09"
  },
  {
    "id": 118,
    "question": "Which of the following best describes data provenance?",
    "choice_a": "The pipeline that transforms and stores data",
    "choice_b": "The real-time path data takes through memory",
    "choice_c": "The statistical summary of model inputs",
    "choice_d": "The origin and collection context of a dataset",
    "correct_answer": "D",
    "explanation": "Data provenance refers to the origin of the data, its collection method, and the conditions under which it was collected, which is essential for legal, ethical, and contextual evaluation.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      497,
      496,
      498,
      404,
      479
    ],
    "source": "363940_Ch09"
  },
  {
    "id": 119,
    "question": "In AI testing, which metric is most appropriate for an imbalanced classification problem?",
    "choice_a": "Accuracy",
    "choice_b": "Recall",
    "choice_c": "Precision",
    "choice_d": "F1 score",
    "correct_answer": "D",
    "explanation": "The F1 score balances precision and recall, making it more reliable than raw accuracy when class distributions are uneven, such as in fraud or medical detection.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      522,
      520,
      415,
      505,
      506
    ],
    "source": "363940_Ch09"
  },
  {
    "id": 120,
    "question": "What is a common risk when model testing lacks subgroup validation?",
    "choice_a": "Decreased model size",
    "choice_b": "Fairness or bias issues in specific populations",
    "choice_c": "Overuse of memory resources",
    "choice_d": "Reduced training time",
    "correct_answer": "B",
    "explanation": "Neglecting subgroup validation can mask performance disparities across demographic groups, introducing or perpetuating algorithmic bias.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      507,
      522,
      520,
      554,
      505
    ],
    "source": "363940_Ch09"
  },
  {
    "id": 121,
    "question": "What is the main distinction between data lineage and data provenance?",
    "choice_a": "Lineage tracks flow and transformations; provenance identifies origin and context",
    "choice_b": "Lineage refers to external sources; provenance refers to internal flows",
    "choice_c": "Lineage is legal; provenance is technical",
    "choice_d": "There is no practical difference",
    "correct_answer": "A",
    "explanation": "Data lineage tracks the lifecycle and processing of data, while provenance identifies its origin, licensing, and collection context. Both are necessary for traceability.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      496,
      497,
      498,
      405,
      483
    ],
    "source": "363940_Ch09"
  },
  {
    "id": 122,
    "question": "Which of the following is an example of an adversarial risk in AI systems?",
    "choice_a": "Long response times under peak load",
    "choice_b": "Poor recall on minority class samples",
    "choice_c": "Inputs crafted to cause model misclassification",
    "choice_d": "Model convergence failure during training",
    "correct_answer": "C",
    "explanation": "Adversarial examples are intentionally designed inputs that cause AI models to produce incorrect or unexpected outputs, often without obvious errors to humans.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      507,
      575,
      577,
      505,
      562
    ],
    "source": "363940_Ch09"
  },
  {
    "id": 123,
    "question": "What is the goal of counterfactual fairness testing?",
    "choice_a": "To test model performance on future datasets",
    "choice_b": "To simulate random inputs",
    "choice_c": "To evaluate if changing a protected attribute affects model output",
    "choice_d": "To measure runtime performance under varying loads",
    "correct_answer": "C",
    "explanation": "Counterfactual fairness assesses whether a model’s decision would change if a sensitive attribute (for example, gender, race, or political affiliation) were altered, while keeping all other factors constant.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      507,
      520,
      554,
      536,
      579
    ],
    "source": "363940_Ch09"
  },
  {
    "id": 124,
    "question": "Why is integration testing important for AI systems?",
    "choice_a": "It reduces GPU costs",
    "choice_b": "It ensures that model predictions are legally compliant",
    "choice_c": "It confirms that different system components work together correctly",
    "choice_d": "It guarantees interpretability",
    "correct_answer": "C",
    "explanation": "Integration testing validates the end-to-end functionality of the system, ensuring that data flows, API calls, and downstream systems properly interact with the AI model.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      506,
      452,
      505,
      521,
      403
    ],
    "source": "363940_Ch09"
  },
  {
    "id": 125,
    "question": "Which activity is most critical during the training phase for identifying model learning problems?",
    "choice_a": "Reviewing deployment logs",
    "choice_b": "Inspecting feature importance",
    "choice_c": "Monitoring convergence and loss curves",
    "choice_d": "Testing production APIs",
    "correct_answer": "C",
    "explanation": "Monitoring loss curves and training metrics during the training phase helps detect problems such as non-convergence, vanishing gradients, or early overfitting.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      521,
      520,
      519,
      444,
      505
    ],
    "source": "363940_Ch09"
  },
  {
    "id": 126,
    "question": "What is the benefit of using model cards or fact sheets in AI testing and deployment?",
    "choice_a": "They eliminate the need for validation testing",
    "choice_b": "They automate model tuning",
    "choice_c": "They increase the learning rate during training",
    "choice_d": "They provide structured transparency about model behavior and limitations",
    "correct_answer": "D",
    "explanation": "Model cards summarize key information about a model’s training data, performance, limitations, and intended use, thereby supporting transparency and fostering stakeholder trust.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      536,
      508,
      403,
      405
    ],
    "source": "363940_Ch09"
  },
  {
    "id": 127,
    "question": "What is the primary purpose of a model card in AI governance?",
    "choice_a": "To document source code for internal reuse",
    "choice_b": "To certify the model’s performance metrics in court",
    "choice_c": "To summarize key information about the model, including purpose, performance, and limitations",
    "choice_d": "To encrypt the model for secure deployment",
    "correct_answer": "C",
    "explanation": "Model cards are standardized documentation tools that provide an explanation of an AI model’s intended use, training data, evaluation results, ethical considerations, and limitations. They support transparency and accountability.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      606,
      546,
      565,
      608,
      597
    ],
    "source": "363940_Ch10"
  },
  {
    "id": 128,
    "question": "Which deployment environment is most suitable for low-latency, privacy-sensitive AI applications?",
    "choice_a": "Public cloud",
    "choice_b": "On-premises data center",
    "choice_c": "Shared hosting platform",
    "choice_d": "Edge device",
    "correct_answer": "D",
    "explanation": "Edge deployment reduces latency and avoids transmitting sensitive data to centralized servers, making it ideal for real-time, privacy-focused applications.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      213,
      617,
      547,
      214
    ],
    "source": "363940_Ch10"
  },
  {
    "id": 129,
    "question": "What is the role of version control in AI deployment?",
    "choice_a": "It tracks changes to model code, configurations, and data over time",
    "choice_b": "It stores user feedback from production systems",
    "choice_c": "It prevents users from accessing outdated documentation",
    "choice_d": "It encrypts the model before it goes live",
    "correct_answer": "A",
    "explanation": "Version control enables traceability and auditability by tracking model changes and ensuring consistency across development and deployment environments.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      546,
      547,
      596,
      565,
      595
    ],
    "source": "363940_Ch10"
  },
  {
    "id": 130,
    "question": "Which of the following best describes concept drift?",
    "choice_a": "An update that changes model hyperparameters",
    "choice_b": "A shift in the relationship between inputs and outputs",
    "choice_c": "A temporary system outage",
    "choice_d": "A scheduled retraining event",
    "correct_answer": "B",
    "explanation": "Concept drift refers to changes in the underlying patterns between input data and expected outputs, often due to real-world shifts.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      554,
      519,
      521,
      481,
      578
    ],
    "source": "363940_Ch10"
  },
  {
    "id": 131,
    "question": "What is a key feature of retrieval augmented generation (RAG)?",
    "choice_a": "The model automatically self-retrains based on user input",
    "choice_b": "It compresses the model to reduce latency",
    "choice_c": "It queries external data sources during inference to enhance accuracy",
    "choice_d": "It anonymizes training data for compliance",
    "correct_answer": "C",
    "explanation": "RAG systems supplement model outputs by retrieving recent, relevant data from an external knowledge base, reducing hallucinations and improving accuracy.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      404,
      449,
      442,
      480,
      479
    ],
    "source": "363940_Ch10"
  },
  {
    "id": 132,
    "question": "Which team typically owns the responsibility for monitoring data lineage and access compliance?",
    "choice_a": "IT operations",
    "choice_b": "Data governance",
    "choice_c": "Marketing",
    "choice_d": "End users",
    "correct_answer": "B",
    "explanation": "Data governance teams are responsible for ensuring data usage aligns with policies, including tracking lineage, enforcing access controls, and maintaining compliance.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      479,
      482,
      483,
      496,
      464
    ],
    "source": "363940_Ch10"
  },
  {
    "id": 133,
    "question": "Why is it essential to include a rollback plan in AI deployment procedures?",
    "choice_a": "To avoid needing a model card",
    "choice_b": "To meet encryption requirements",
    "choice_c": "To quickly restore a prior state in case of failure or harm",
    "choice_d": "To reduce licensing costs",
    "correct_answer": "C",
    "explanation": "Rollback plans enable rapid recovery from harmful or faulty AI behaviors by reverting to a safe model version or configuration.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      546,
      547,
      587,
      191,
      431
    ],
    "source": "363940_Ch10"
  },
  {
    "id": 134,
    "question": "Which of the following is a good indicator that a deployed AI model may be exhibiting fairness issues?",
    "choice_a": "Reduced GPU usage",
    "choice_b": "Consistent latency across regions",
    "choice_c": "Fewer API requests from users",
    "choice_d": "Disparities in outcomes for different demographic groups",
    "correct_answer": "D",
    "explanation": "Fairness issues often appear as unequal treatment across groups. Monitoring these disparities is a key ethical and governance practice.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      214,
      547,
      596,
      429,
      259
    ],
    "source": "363940_Ch10"
  },
  {
    "id": 135,
    "question": "What is the primary function of a “shadow model” in AI operations?",
    "choice_a": "To simulate attacks for penetration testing",
    "choice_b": "To generate synthetic training data",
    "choice_c": "To operate alongside the live model for comparison and drift detection",
    "choice_d": "To block unauthorized access attempts",
    "correct_answer": "C",
    "explanation": "Shadow models run in parallel with production models to detect drift or performance degradation by comparing outputs over time.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      547,
      596,
      564,
      597,
      565
    ],
    "source": "363940_Ch10"
  },
  {
    "id": 136,
    "question": "Why should AI retraining schedules be based on model volatility and risk exposure?",
    "choice_a": "To match software patch cycles",
    "choice_b": "To fulfill entertainment value in user experiences",
    "choice_c": "To optimize system cooling requirements",
    "choice_d": "To balance model freshness with resource constraints and potential harm",
    "correct_answer": "D",
    "explanation": "Frequent retraining helps maintain relevance but incurs costs. High-risk, fast-changing contexts require more frequent updates to prevent harm and maintain accuracy.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      547,
      564,
      565,
      595,
      546
    ],
    "source": "363940_Ch10"
  },
  {
    "id": 137,
    "question": "Which of the following is most critical when forecasting downstream harm from an AI system?",
    "choice_a": "Stakeholder impact mapping",
    "choice_b": "Model inference speed",
    "choice_c": "Data labeling automation",
    "choice_d": "Algorithm version numbering",
    "correct_answer": "A",
    "explanation": "Stakeholder impact mapping helps forecast downstream harm by identifying who may be affected by unintended consequences of the AI system.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      428,
      429,
      564,
      427,
      430
    ],
    "source": "363940_Ch11"
  },
  {
    "id": 138,
    "question": "What is the primary goal of red teaming in AI assurance?",
    "choice_a": "Increasing model accuracy",
    "choice_b": "Identifying adversarial vulnerabilities and misuse scenarios",
    "choice_c": "Reducing training costs",
    "choice_d": "Automating model updates",
    "correct_answer": "B",
    "explanation": "Red teaming focuses on simulating attacks or misuse scenarios to uncover vulnerabilities that typical testing might miss.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      547,
      587,
      191,
      564,
      429
    ],
    "source": "363940_Ch11"
  },
  {
    "id": 139,
    "question": "Which clause in a vendor agreement could most directly affect the organization’s data governance obligations?",
    "choice_a": "Termination clause",
    "choice_b": "Model refresh schedule",
    "choice_c": "Data usage rights",
    "choice_d": "Warranty exclusions",
    "correct_answer": "C",
    "explanation": "Data usage rights define how vendor systems can access, use, or retain data—impacting privacy compliance and ownership.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      480,
      464,
      479,
      482,
      416
    ],
    "source": "363940_Ch11"
  },
  {
    "id": 140,
    "question": "What is the best method for detecting model drift after deployment?",
    "choice_a": "Comparing audit logs with the risk register",
    "choice_b": "Rereading the model documentation",
    "choice_c": "Conducting monthly user surveys",
    "choice_d": "Monitoring shifts in input or output data distributions",
    "correct_answer": "D",
    "explanation": "Model drift is typically detected by monitoring statistical changes in input/output distributions over time.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      547,
      596,
      564,
      278,
      597
    ],
    "source": "363940_Ch11"
  },
  {
    "id": 141,
    "question": "An AI chatbot begins generating biased or toxic responses. What is the most appropriate first step?",
    "choice_a": "Increase its training epochs",
    "choice_b": "Escalate the incident and disable the model temporarily",
    "choice_c": "Ignore the issue and monitor it over time",
    "choice_d": "Retrain the model on different hardware",
    "correct_answer": "B",
    "explanation": "In safety-critical contexts, containment is essential. Disabling the model limits exposure while the investigation is ongoing.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      547,
      191,
      587,
      595,
      596
    ],
    "source": "363940_Ch11"
  },
  {
    "id": 142,
    "question": "Which of the following best describes a “shadow deployment”?",
    "choice_a": "A deployment of an untested model to the public",
    "choice_b": "A model released under a different product name",
    "choice_c": "A model run in parallel without impacting end users",
    "choice_d": "An outdated model left running without documentation",
    "correct_answer": "C",
    "explanation": "A shadow deployment enables the testing of a new model in production without affecting users, thereby supporting a safe evaluation.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      546,
      547,
      431,
      596,
      565
    ],
    "source": "363940_Ch11"
  },
  {
    "id": 143,
    "question": "Which regulatory framework explicitly requires post-market monitoring for high-risk AI systems?",
    "choice_a": "EU AI Act",
    "choice_b": "California CPRA",
    "choice_c": "Brazil LGPD",
    "choice_d": "ISO/IEC 27001",
    "correct_answer": "A",
    "explanation": "The EU AI Act mandates post-market monitoring of high-risk AI systems, including documenting incidents and developing incident response plans.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      587,
      596,
      547,
      607,
      427
    ],
    "source": "363940_Ch11"
  },
  {
    "id": 144,
    "question": "What is the key difference between a performance audit and a threat model?",
    "choice_a": "Threat modeling is conducted after deployment",
    "choice_b": "Performance audits assess legal compliance",
    "choice_c": "Threat modeling identifies attack vectors; audits evaluate functional behavior",
    "choice_d": "Performance audits focus on infrastructure, not on AI",
    "correct_answer": "C",
    "explanation": "Threat modeling is a security-focused approach, while performance audits verify system behavior against its intended outcomes.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      596,
      259,
      616,
      547,
      214
    ],
    "source": "363940_Ch11"
  },
  {
    "id": 145,
    "question": "Why is prompt injection a significant concern for generative AI systems?",
    "choice_a": "It slows inference times",
    "choice_b": "It may bypass safety mechanisms and produce harmful outputs",
    "choice_c": "It can overwrite hyperparameters",
    "choice_d": "It only affects offline training models",
    "correct_answer": "B",
    "explanation": "Prompt injection manipulates the model’s behavior, potentially causing it to generate outputs outside its safety constraints.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      191,
      547,
      587,
      565,
      427
    ],
    "source": "363940_Ch11"
  },
  {
    "id": 146,
    "question": "What is the purpose of linking incident records to the AI risk register?",
    "choice_a": "To consolidate training logs",
    "choice_b": "To simplify contract negotiation",
    "choice_c": "To ensure discovered risks are tracked, evaluated, and managed",
    "choice_d": "To reduce model latency",
    "correct_answer": "C",
    "explanation": "Linking incidents to the risk register ensures new or recurring risks are formally tracked and mitigated in governance processes.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      595,
      565,
      547,
      596,
      597
    ],
    "source": "363940_Ch11"
  },
  {
    "id": 147,
    "question": "Which of the following is the primary purpose of documenting AI system incidents?",
    "choice_a": "To prepare for marketing campaigns",
    "choice_b": "To increase model accuracy during training",
    "choice_c": "To support audits, accountability, and compliance",
    "choice_d": "To automate retirement decisions",
    "correct_answer": "C",
    "explanation": "Documenting incidents supports transparency, regulatory compliance, and audit readiness by providing a detailed record of deviations from expected behavior.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      595,
      587,
      596,
      191,
      597
    ],
    "source": "363940_Ch12"
  },
  {
    "id": 148,
    "question": "What is a key feature of a post-market monitoring plan for AI systems?",
    "choice_a": "Ongoing evaluation of system performance and risks",
    "choice_b": "Dynamic pricing optimization",
    "choice_c": "Real-time stock trading integration",
    "choice_d": "Legal review of all user interactions",
    "correct_answer": "A",
    "explanation": "Post-market monitoring ensures that deployed AI systems are continuously evaluated for accuracy, fairness, and unintended harms in real-world use.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      596,
      547,
      278,
      564,
      595
    ],
    "source": "363940_Ch12"
  },
  {
    "id": 149,
    "question": "In an external communication strategy, what should be included when describing an AI system?",
    "choice_a": "Source code and API credentials",
    "choice_b": "Marketing slogans and social media plans",
    "choice_c": "User passwords and login behavior",
    "choice_d": "System purpose, limitations, and human involvement",
    "correct_answer": "D",
    "explanation": "Effective communication includes disclosing what the system does, its limitations, and the extent of human oversight involved.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      606,
      608,
      430,
      278,
      548
    ],
    "source": "363940_Ch12"
  },
  {
    "id": 150,
    "question": "What is the primary function of an AI system retirement policy?",
    "choice_a": "To suppress complaints from end users",
    "choice_b": "To extend AI model use indefinitely",
    "choice_c": "To guide the responsible deactivation of systems",
    "choice_d": "To prevent transparency in decommissioning",
    "correct_answer": "C",
    "explanation": "A retirement policy ensures systems are deactivated in a controlled, risk-aware manner, preserving data integrity and compliance.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      616,
      617,
      618,
      546,
      596
    ],
    "source": "363940_Ch12"
  },
  {
    "id": 151,
    "question": "Which of the following most likely triggers the localization of an AI system?",
    "choice_a": "High user satisfaction in one market",
    "choice_b": "Cultural or legal differences across regions",
    "choice_c": "Stable training data distributions",
    "choice_d": "Shared model weights across all use cases",
    "correct_answer": "B",
    "explanation": "Legal mandates (for example, data sovereignty) and cultural norms often require that AI systems be localized or redeployed regionally.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      617,
      427,
      597,
      565,
      213
    ],
    "source": "363940_Ch12"
  },
  {
    "id": 152,
    "question": "What distinguishes an “issue” from an “incident” in AI operations?",
    "choice_a": "Incidents only occur in training environments",
    "choice_b": "Issues are generally lower in severity and may not require immediate response",
    "choice_c": "Incidents are optional to report; issues are mandatory",
    "choice_d": "Issues always involve user data loss",
    "correct_answer": "B",
    "explanation": "Issues are often minor problems or observations, whereas incidents typically involve significant failures that require prompt action.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      595,
      587,
      191,
      547,
      565
    ],
    "source": "363940_Ch12"
  },
  {
    "id": 153,
    "question": "Why should deactivated AI models be archived rather than deleted immediately?",
    "choice_a": "To support legal, audit, and accountability requirements",
    "choice_b": "To enable unauthorized reuse in other products",
    "choice_c": "To avoid storage costs",
    "choice_d": "To meet SEO guidelines",
    "correct_answer": "A",
    "explanation": "Archiving models allows organizations to retain historical performance data and evidence of compliance with governance obligations.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      618,
      596,
      616,
      597,
      595
    ],
    "source": "363940_Ch12"
  },
  {
    "id": 154,
    "question": "What is a key consideration when preparing for AI system retirement?",
    "choice_a": "Increasing the model’s prediction speed",
    "choice_b": "Releasing source code into the public domain",
    "choice_c": "Assessing dependencies and planning fallback options",
    "choice_d": "Disabling user feedback channels",
    "correct_answer": "C",
    "explanation": "Understanding how other systems rely on the AI model enables a smoother transition and prevents service disruptions.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      617,
      616,
      618,
      608,
      546
    ],
    "source": "363940_Ch12"
  },
  {
    "id": 155,
    "question": "Under which regulation is public registration of high-risk AI systems required?",
    "choice_a": "GDPR",
    "choice_b": "California Consumer Privacy Act",
    "choice_c": "EU AI Act",
    "choice_d": "ISO/IEC 27001",
    "correct_answer": "C",
    "explanation": "The EU AI Act requires that high-risk AI systems be registered, accompanied by technical documentation and risk mitigation plans.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      597,
      427,
      565,
      607,
      428
    ],
    "source": "363940_Ch12"
  },
  {
    "id": 156,
    "question": "What is a best practice for communicating AI limitations to users?",
    "choice_a": "Use clear, plain language with real-world examples",
    "choice_b": "Use vague language to avoid liability",
    "choice_c": "Provide highly technical white papers only",
    "choice_d": "Avoid mentioning limitations to prevent user doubt",
    "correct_answer": "A",
    "explanation": "Using plain language and relatable examples helps users understand system constraints, promoting informed and responsible use.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      608,
      606,
      548,
      278,
      431
    ],
    "source": "363940_Ch12"
  },
  {
    "id": 157,
    "question": "Which statement best describes the primary objective of AI governance?",
    "choice_a": "Reduce model-training cost",
    "choice_b": "Centralize data storage",
    "choice_c": "Automate decision-making across all processes",
    "choice_d": "Ensure AI is lawful, ethical, and accountable",
    "correct_answer": "D",
    "explanation": "AI governance establishes oversight and accountability to ensure AI systems operate within ethical and legal limits.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      60,
      42,
      30,
      117,
      39
    ],
    "source": "363940_PracticeTest_01"
  },
  {
    "id": 158,
    "question": "What principle requires that humans retain ultimate decision authority over AI systems?",
    "choice_a": "Transparency",
    "choice_b": "Human-in-command",
    "choice_c": "Explainability",
    "choice_d": "Scalability",
    "correct_answer": "B",
    "explanation": "Human-in-command oversight ensures people remain responsible for the activation, supervision, suspension, or override of AI, preserving accountability and ethical oversight.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      42,
      123,
      29,
      104,
      63
    ],
    "source": "363940_PracticeTest_01"
  },
  {
    "id": 159,
    "question": "An organization discloses model-performance summaries on its website. Which governance objective does this fulfill?",
    "choice_a": "Transparency and accountability",
    "choice_b": "Operational efficiency",
    "choice_c": "Vendor marketing",
    "choice_d": "Bias reduction",
    "correct_answer": "A",
    "explanation": "Public transparency reports communicate reliability and limitations, strengthening accountability.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      606,
      608,
      278,
      587,
      431
    ],
    "source": "363940_PracticeTest_01"
  },
  {
    "id": 160,
    "question": "A company establishes an AI ethics board that is empowered to review and stop deployments. What maturity milestone does this show?",
    "choice_a": "Initial",
    "choice_b": "Managed",
    "choice_c": "Defined",
    "choice_d": "Ad hoc",
    "correct_answer": "B",
    "explanation": "Managed maturity includes formal authority for ethical review and enforcement.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      97,
      61,
      123,
      75,
      60
    ],
    "source": "363940_PracticeTest_01"
  },
  {
    "id": 161,
    "question": "Why should AI governance be integrated into Enterprise Risk Management?",
    "choice_a": "To reduce documentation",
    "choice_b": "To eliminate audits",
    "choice_c": "To accelerate model release",
    "choice_d": "To align AI risks with corporate risk appetite and reporting",
    "correct_answer": "D",
    "explanation": "Integrated oversight provides broad and consistent visibility, accountability, and informed decision-making across business functions.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      99,
      60,
      74,
      124,
      117
    ],
    "source": "363940_PracticeTest_01"
  },
  {
    "id": 162,
    "question": "An organization standardizes AI project templates and reviews. What maturity level is this?",
    "choice_a": "Repeatable",
    "choice_b": "Opportunistic",
    "choice_c": "Optimized",
    "choice_d": "Experimental",
    "correct_answer": "A",
    "explanation": "Repeatable maturity means processes are documented and consistently applied, though not yet fully optimized.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      97,
      63,
      75,
      122,
      87
    ],
    "source": "363940_PracticeTest_01"
  },
  {
    "id": 163,
    "question": "A contract requires the vendor to document dataset origin and proof of user consent. Which control is applied?",
    "choice_a": "Drift detection",
    "choice_b": "Audit sampling",
    "choice_c": "Version control",
    "choice_d": "Provenance verification",
    "correct_answer": "D",
    "explanation": "Provenance verification ensures that all datasets used for AI development are lawfully obtained, traceable, and properly consented.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      120,
      159,
      158,
      157,
      124
    ],
    "source": "363940_PracticeTest_01"
  },
  {
    "id": 164,
    "question": "Integrating AI policy with IT change-management procedures achieves what?",
    "choice_a": "Faster compute performance",
    "choice_b": "Marketing efficiency",
    "choice_c": "Continuous compliance throughout the lifecycle",
    "choice_d": "Fewer audits",
    "correct_answer": "C",
    "explanation": "Lifecycle integration embeds compliance into established operational processes.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      117,
      63,
      123,
      74,
      87
    ],
    "source": "363940_PracticeTest_01"
  },
  {
    "id": 165,
    "question": "An AI system collects personal data without user notice. Which privacy principle is violated?",
    "choice_a": "Lawfulness",
    "choice_b": "All of these",
    "choice_c": "Transparency",
    "choice_d": "Purpose limitation",
    "correct_answer": "B",
    "explanation": "Uninformed data collection breaches multiple fundamental principles under privacy law.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      172,
      181,
      176,
      192,
      177
    ],
    "source": "363940_PracticeTest_01"
  },
  {
    "id": 166,
    "question": "Which safeguard is mandatory when processing biometric data for identification?",
    "choice_a": "Encryption only",
    "choice_b": "Aggregation",
    "choice_c": "DPIA and explicit consent",
    "choice_d": "Tokenization",
    "correct_answer": "C",
    "explanation": "Biometric processing is high-risk and requires explicit consent and an impact assessment.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      208,
      187,
      207,
      216
    ],
    "source": "363940_PracticeTest_01"
  },
  {
    "id": 167,
    "question": "A generative-art AI reproduces portions of protected imagery. Which factor most undermines a fair-use defense?",
    "choice_a": "Public data source",
    "choice_b": "Minimal copying",
    "choice_c": "Commercial substitution of the original",
    "choice_d": "Non-profit research intent",
    "correct_answer": "C",
    "explanation": "Substituting or competing outputs for originals harms market value and defeats fair-use claims.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      231,
      234,
      233,
      235,
      237
    ],
    "source": "363940_PracticeTest_01"
  },
  {
    "id": 168,
    "question": "An AI-powered health-advice bot shares symptom data with advertisers. Which U.S. law could apply?",
    "choice_a": "HIPAA",
    "choice_b": "ECOA",
    "choice_c": "FERPA",
    "choice_d": "COPPA",
    "correct_answer": "A",
    "explanation": "HIPAA (Health Insurance Portability and Accountability Act) restricts disclosure of protected health information without authorization.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      209,
      275,
      274
    ],
    "source": "363940_PracticeTest_01"
  },
  {
    "id": 169,
    "question": "A children’s learning app uses AI profiling without parental consent. Which law is breached?",
    "choice_a": "COPPA",
    "choice_b": "ECOA",
    "choice_c": "GLBA",
    "choice_d": "FCRA",
    "correct_answer": "A",
    "explanation": "COPPA (Children’s Online Privacy Protection Act) requires verifiable parental consent before collecting children’s data.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      275,
      172,
      274,
      212,
      208
    ],
    "source": "363940_PracticeTest_01"
  },
  {
    "id": 170,
    "question": "An AI lending system excludes applicants by postal code. Which risk arises?",
    "choice_a": "Low accuracy",
    "choice_b": "Disparate-impact discrimination",
    "choice_c": "Data duplication",
    "choice_d": "Latency variance",
    "correct_answer": "B",
    "explanation": "A postal code can act as a proxy for protected characteristics, thereby violating anti-discrimination law.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      254,
      256,
      257,
      258,
      211
    ],
    "source": "363940_PracticeTest_01"
  },
  {
    "id": 171,
    "question": "Why must high-risk AI systems undergo conformity assessment before EU market entry?",
    "choice_a": "To verify compliance with EU AI Act safety and governance standards",
    "choice_b": "To reduce licensing cost",
    "choice_c": "To qualify for subsidies",
    "choice_d": "To avoid human oversight",
    "correct_answer": "A",
    "explanation": "Conformity assessments confirm alignment with legal and technical obligations.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      317,
      311,
      316,
      337,
      332
    ],
    "source": "363940_PracticeTest_01"
  },
  {
    "id": 172,
    "question": "Which AI category is explicitly prohibited by the EU AI Act?",
    "choice_a": "Predictive maintenance models",
    "choice_b": "Academic research prototypes",
    "choice_c": "Social-scoring systems by public authorities",
    "choice_d": "Edge-deployed sensors",
    "correct_answer": "C",
    "explanation": "Government social scoring in the EU is banned due to rights and discrimination risks.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      311,
      316,
      254,
      216,
      211
    ],
    "source": "363940_PracticeTest_01"
  },
  {
    "id": 173,
    "question": "What does the “Govern” function of the NIST AI RMF establish?",
    "choice_a": "Roles, accountability, and culture for responsible AI",
    "choice_b": "Testing procedures",
    "choice_c": "Encryption protocols",
    "choice_d": "Deployment automation",
    "correct_answer": "A",
    "explanation": "“Govern” defines the structure and oversight culture as the framework’s foundation.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      350,
      349,
      354,
      382,
      178
    ],
    "source": "363940_PracticeTest_01"
  },
  {
    "id": 174,
    "question": "Under ISO/IEC 42001, why align AI governance with ISO/IEC 27001?",
    "choice_a": "Enables unified management system audits and continuous improvement",
    "choice_b": "Simplifies vendor licensing",
    "choice_c": "Reduces transparency",
    "choice_d": "Removes legal oversight",
    "correct_answer": "A",
    "explanation": "ISO/IEC 42001 (“Information technology—Artificial intelligence—Management system”) shares the Annex structure with ISO/IEC 27001 (“Information security, cybersecurity and privacy protection—Information security management systems—Requirements”) and ISO 9001 (“Quality management systems—Requirements”), enabling integrated audits, continuous improvement, and efficient oversight across AI, security, and quality domains.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      383,
      382,
      354,
      395,
      350
    ],
    "source": "363940_PracticeTest_01"
  },
  {
    "id": 175,
    "question": "A design team logs all data transformations for model training. Which principle is supported?",
    "choice_a": "Latency",
    "choice_b": "Scalability",
    "choice_c": "Traceability",
    "choice_d": "Cost control",
    "correct_answer": "C",
    "explanation": "Maintaining detailed logs of data transformations supports traceability, ensuring the AI system’s data lineage and training processes can be reconstructed and audited.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      497,
      496,
      405,
      498,
      404
    ],
    "source": "363940_PracticeTest_01"
  },
  {
    "id": 176,
    "question": "Why should explainability be built into model design rather than added later?",
    "choice_a": "To reduce hardware cost",
    "choice_b": "To improve speed",
    "choice_c": "To bypass human oversight",
    "choice_d": "To yield clearer logic and easier auditing",
    "correct_answer": "D",
    "explanation": "Explainability-by-design ensures transparency, interpretability, and compliance-readiness, as well as reducing rework, later in the lifecycle.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      405,
      465,
      403,
      496,
      442
    ],
    "source": "363940_PracticeTest_01"
  },
  {
    "id": 177,
    "question": "An AI team trains on licensed datasets but fails to retain license proofs. Which governance area is violated?",
    "choice_a": "Documentation and provenance control",
    "choice_b": "Testing rigor",
    "choice_c": "Encryption policy",
    "choice_d": "Bias mitigation",
    "correct_answer": "A",
    "explanation": "Maintaining legal documentation verifies lawful use and data ownership.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      480,
      497,
      496,
      405,
      579
    ],
    "source": "363940_PracticeTest_01"
  },
  {
    "id": 178,
    "question": "Model accuracy declines as market behavior changes. What is this condition called?",
    "choice_a": "Overfitting",
    "choice_b": "Quantization",
    "choice_c": "Regularization",
    "choice_d": "Concept drift",
    "correct_answer": "D",
    "explanation": "Concept drift occurs when real-world relationships evolve, requiring retraining.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      554,
      555,
      521,
      553
    ],
    "source": "363940_PracticeTest_01"
  },
  {
    "id": 179,
    "question": "Before launch, a cross-functional team validates compliance and approvals. Which process is this?",
    "choice_a": "Conformity audit",
    "choice_b": "Shadow deployment",
    "choice_c": "Final gate review",
    "choice_d": "Quantization",
    "correct_answer": "C",
    "explanation": "Gate reviews confirm readiness, risk mitigation, and accountability prior to release.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      546,
      431,
      565,
      427,
      548
    ],
    "source": "363940_PracticeTest_01"
  },
  {
    "id": 180,
    "question": "Deploying a hospital AI model at the edge primarily supports which goal?",
    "choice_a": "Protecting patient privacy and reducing latency",
    "choice_b": "Increasing marketing visibility",
    "choice_c": "Simplifying documentation",
    "choice_d": "Enhancing compression",
    "correct_answer": "A",
    "explanation": "Edge computing minimizes data transfer and latency, aligning with privacy mandates and improving performance.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      213,
      546,
      427,
      565,
      617
    ],
    "source": "363940_PracticeTest_01"
  },
  {
    "id": 181,
    "question": "A vendor risk review reveals unclear indemnity for AI errors. Which action is most appropriate?",
    "choice_a": "Proceed without changes",
    "choice_b": "Outsource auditing",
    "choice_c": "Add marketing language",
    "choice_d": "Renegotiate contract to define liability",
    "correct_answer": "D",
    "explanation": "Defined liability clauses allocate accountability for AI-related harms.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      563,
      259,
      236,
      608,
      565
    ],
    "source": "363940_PracticeTest_01"
  },
  {
    "id": 182,
    "question": "A red team uncovers that an AI chatbot reveals fragments of its training data. Which risk category applies?",
    "choice_a": "Operational risk",
    "choice_b": "Data-related risk",
    "choice_c": "Infrastructure risk",
    "choice_d": "Strategic risk",
    "correct_answer": "B",
    "explanation": "Training data leakage is primarily a data‐related risk, though it also intersects with security vulnerabilities.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      562,
      482,
      575,
      507,
      464
    ],
    "source": "363940_PracticeTest_01"
  },
  {
    "id": 183,
    "question": "A regulator requests proof of continuous AI performance monitoring. Which evidence best satisfies the request?",
    "choice_a": "Source code repository",
    "choice_b": "Marketing brochure",
    "choice_c": "Vendor invoice",
    "choice_d": "Drift and bias monitoring logs",
    "correct_answer": "D",
    "explanation": "Monitoring logs provide auditable evidence that fairness and accuracy are tracked throughout the system’s lifecycle.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      596,
      547,
      278,
      597,
      595
    ],
    "source": "363940_PracticeTest_01"
  },
  {
    "id": 184,
    "question": "Why should AI policies be reviewed regularly?",
    "choice_a": "To reduce compute costs",
    "choice_b": "To align with evolving regulations and organizational risk tolerance",
    "choice_c": "To refresh public relations materials",
    "choice_d": "To reduce developer workload",
    "correct_answer": "B",
    "explanation": "Regular policy reviews ensure governance remains current with changing laws and risk context.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      117,
      99,
      148,
      98,
      161
    ],
    "source": "363940_PracticeTest_01"
  },
  {
    "id": 185,
    "question": "Which type of AI requires external notification to users under the EU AI Act?",
    "choice_a": "Edge-deployed sensors",
    "choice_b": "Offline models",
    "choice_c": "Chatbots and other limited-risk systems",
    "choice_d": "Proprietary internal tools",
    "correct_answer": "C",
    "explanation": "Limited-risk AI must disclose that users are interacting with an AI system.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      312,
      318,
      317,
      311,
      337
    ],
    "source": "363940_PracticeTest_01"
  },
  {
    "id": 186,
    "question": "An AI-driven medical device requires human validation of diagnoses before treatment. Which oversight approach is this?",
    "choice_a": "Human-in-the-loop",
    "choice_b": "Fully autonomous",
    "choice_c": "Automated-on-the-loop",
    "choice_d": "No oversight",
    "correct_answer": "A",
    "explanation": "Human-in-the-loop oversight ensures human confirmation before executing consequential decisions.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      430,
      259,
      548,
      427,
      547
    ],
    "source": "363940_PracticeTest_01"
  },
  {
    "id": 187,
    "question": "A global firm runs sentiment analysis on customer voice calls. Which U.S. privacy law might apply if health information is discussed?",
    "choice_a": "GLBA",
    "choice_b": "HIPAA",
    "choice_c": "COPPA",
    "choice_d": "ECOA",
    "correct_answer": "B",
    "explanation": "Voice data containing health details can qualify as protected health information under HIPAA (Health Insurance Portability and Accountability Act).",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      209,
      207,
      212,
      208,
      275
    ],
    "source": "363940_PracticeTest_01"
  },
  {
    "id": 188,
    "question": "A high-risk AI provider changes its model post-certification. What must it do to comply with the EU AI Act?",
    "choice_a": "Notify customers only",
    "choice_b": "Delay reporting for a year",
    "choice_c": "Archive model logs",
    "choice_d": "Conduct a new conformity assessment",
    "correct_answer": "D",
    "explanation": "Significant modifications require a fresh conformity review to maintain compliance.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      317,
      311,
      316,
      299,
      337
    ],
    "source": "363940_PracticeTest_01"
  },
  {
    "id": 189,
    "question": "What is the main benefit of adopting ISO/IEC 22989 in AI governance?",
    "choice_a": "Faster compute processing",
    "choice_b": "Consistent terminology across projects",
    "choice_c": "Automated bias detection",
    "choice_d": "Lower licensing fees",
    "correct_answer": "B",
    "explanation": "ISO/IEC 22989 (“Information technology—Artificial intelligence—Artificial intelligence concepts and terminology”) standardizes terminology and concepts, improving communication and consistency.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      381,
      384,
      395,
      382,
      182
    ],
    "source": "363940_PracticeTest_01"
  },
  {
    "id": 190,
    "question": "Why should model explainability be tested with non-technical stakeholders?",
    "choice_a": "To improve system performance",
    "choice_b": "To test encryption",
    "choice_c": "To confirm the clarity and usability of explanations",
    "choice_d": "To validate compute budgets",
    "correct_answer": "C",
    "explanation": "Governance should ensure that explanations are understandable to end users and decision-makers.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      548,
      606,
      430,
      608,
      259
    ],
    "source": "363940_PracticeTest_01"
  },
  {
    "id": 191,
    "question": "A risk register shows unmitigated high-risk items accepted by management. What governance element ensures accountability?",
    "choice_a": "External audit",
    "choice_b": "Documented residual-risk acceptance",
    "choice_c": "Quarterly report",
    "choice_d": "Bias testing",
    "correct_answer": "B",
    "explanation": "Recorded acceptance with signoff demonstrates formal accountability in risk management.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      595,
      565,
      431,
      596,
      597
    ],
    "source": "363940_PracticeTest_01"
  },
  {
    "id": 192,
    "question": "A data-science team loses track of data sources during retraining. What requirement has failed?",
    "choice_a": "Accuracy testing",
    "choice_b": "Provenance and traceability",
    "choice_c": "Quantization",
    "choice_d": "Documentation retention",
    "correct_answer": "B",
    "explanation": "Provenance provides data lineage and legal compliance; its absence undermines compliance and audit readiness.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      496,
      497,
      405,
      498,
      404
    ],
    "source": "363940_PracticeTest_01"
  },
  {
    "id": 193,
    "question": "Why must model retirement be documented formally?",
    "choice_a": "To provide evidence of lifecycle completion and compliance",
    "choice_b": "To reduce dataset size",
    "choice_c": "To minimize retraining cost",
    "choice_d": "To satisfy marketing",
    "correct_answer": "A",
    "explanation": "Proper decommissioning records demonstrate responsible AI lifecycle management, reducing compliance risk.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      616,
      618,
      617,
      597,
      596
    ],
    "source": "363940_PracticeTest_01"
  },
  {
    "id": 194,
    "question": "Which NIST AI RMF function evaluates potential impact and context of AI use?",
    "choice_a": "Map",
    "choice_b": "Measure",
    "choice_c": "Manage",
    "choice_d": "Govern",
    "correct_answer": "A",
    "explanation": "The “Map” function establishes use context, stakeholders, and risk exposure for planning controls.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      351,
      349,
      354,
      178,
      384
    ],
    "source": "363940_PracticeTest_01"
  },
  {
    "id": 195,
    "question": "A generative AI system trained on public data reveals personal details. What compliance safeguard could have prevented this?",
    "choice_a": "Model compression",
    "choice_b": "Feature pruning",
    "choice_c": "Quantization",
    "choice_d": "Differential privacy",
    "correct_answer": "D",
    "explanation": "Differential privacy limits the possibility of personal data reconstruction from model outputs.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      482,
      536,
      464,
      404,
      481
    ],
    "source": "363940_PracticeTest_01"
  },
  {
    "id": 196,
    "question": "An insurance company AI tool’s training data becomes outdated after a year. What corrective action should be taken?",
    "choice_a": "Reduce sampling",
    "choice_b": "Ignore drift until incident occurs",
    "choice_c": "Retrain and validate with updated datasets",
    "choice_d": "Increase model depth",
    "correct_answer": "C",
    "explanation": "Periodic retraining ensures continuing accuracy and fairness as real-world conditions evolve.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      555,
      554,
      578,
      521,
      553
    ],
    "source": "363940_PracticeTest_01"
  },
  {
    "id": 197,
    "question": "A legal team reviews AI product descriptions before release. Why?",
    "choice_a": "To optimize compute time",
    "choice_b": "To bypass audits",
    "choice_c": "To accelerate launch",
    "choice_d": "To prevent false or exaggerated capability claims",
    "correct_answer": "D",
    "explanation": "Pre-approval of marketing communications ensures truthful, compliant external messaging.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      278,
      606,
      607,
      608,
      587
    ],
    "source": "363940_PracticeTest_01"
  },
  {
    "id": 198,
    "question": "A lender’s AI model disproportionately rejects applicants from a minority group. What is the first appropriate governance response?",
    "choice_a": "Delete all logs",
    "choice_b": "Publicly disclose source code",
    "choice_c": "Disable encryption",
    "choice_d": "Launch an incident investigation and bias remediation plan",
    "correct_answer": "D",
    "explanation": "Fairness violations require documented investigation and mitigation as part of incident management.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      547,
      595,
      259,
      587,
      596
    ],
    "source": "363940_PracticeTest_01"
  },
  {
    "id": 199,
    "question": "Why do organizations conduct red team testing before AI deployment?",
    "choice_a": "To speed up training",
    "choice_b": "To lower audit frequency",
    "choice_c": "To test energy efficiency",
    "choice_d": "To identify vulnerabilities and improve robustness",
    "correct_answer": "D",
    "explanation": "Red teaming simulates adversarial conditions, improving reliability and security when vulnerabilities are remediated.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      259,
      427,
      563,
      548,
      547
    ],
    "source": "363940_PracticeTest_01"
  },
  {
    "id": 200,
    "question": "Which key privacy requirement applies before transferring EU personal data to non-EEA locations?",
    "choice_a": "Encryption only",
    "choice_b": "Vendor self-attestation",
    "choice_c": "Transfer Impact Assessment and safeguard mechanism (for example, SCCs)",
    "choice_d": "Local code audit",
    "correct_answer": "C",
    "explanation": "Before transferring EU personal data to non-EEA locations, organizations must assess transfer risks and ensure adequate safeguards under GDPR Article 46.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      189,
      188,
      187,
      177,
      181
    ],
    "source": "363940_PracticeTest_01"
  },
  {
    "id": 201,
    "question": "A global company aligns its AI oversight to the OECD AI Principles. What benefit does this provide?",
    "choice_a": "Replaces all local regulations",
    "choice_b": "Removes bias testing",
    "choice_c": "Promotes fairness, accountability, and human-centric design",
    "choice_d": "Avoids transparency",
    "correct_answer": "C",
    "explanation": "OECD principles encourage trustworthy AI aligned with democratic values and human rights.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      345,
      395,
      394,
      254,
      192
    ],
    "source": "363940_PracticeTest_01"
  },
  {
    "id": 202,
    "question": "Why should AI teams log all model versions and configurations?",
    "choice_a": "To support reproducibility and traceability",
    "choice_b": "To anonymize data",
    "choice_c": "To reduce inference time",
    "choice_d": "To improve explainability",
    "correct_answer": "A",
    "explanation": "Version tracking allows repeatable validation, improved troubleshooting, and complete audit trails.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      405,
      404,
      498,
      497,
      579
    ],
    "source": "363940_PracticeTest_01"
  },
  {
    "id": 203,
    "question": "An AI ethics board recommends halting a deployment until bias testing is complete. Which governance strength is shown?",
    "choice_a": "Excessive oversight",
    "choice_b": "Independent review authority",
    "choice_c": "Lack of process",
    "choice_d": "Developer autonomy",
    "correct_answer": "B",
    "explanation": "Independent boards with decision-making power provide checks and accountability.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      61,
      123,
      75,
      60,
      42
    ],
    "source": "363940_PracticeTest_01"
  },
  {
    "id": 204,
    "question": "A developer adds training data from a social media site without license verification. Which legal exposure results?",
    "choice_a": "Latency delay",
    "choice_b": "Cost overrun",
    "choice_c": "Copyright infringement",
    "choice_d": "Overfitting",
    "correct_answer": "C",
    "explanation": "Using copyrighted or unlicensed data without permission violates IP law. There may also be a privacy issue in this instance.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      233,
      234,
      231,
      232,
      238
    ],
    "source": "363940_PracticeTest_01"
  },
  {
    "id": 205,
    "question": "An AI provider issues a “post-market monitoring plan.” What is its function?",
    "choice_a": "Manage marketing budgets",
    "choice_b": "Validate ongoing accuracy, safety, and compliance",
    "choice_c": "Replace audits",
    "choice_d": "Track vendor payments",
    "correct_answer": "B",
    "explanation": "Post-market monitoring ensures long-term model integrity and regulatory adherence.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      596,
      547,
      278,
      565,
      595
    ],
    "source": "363940_PracticeTest_01"
  },
  {
    "id": 206,
    "question": "Why are immutable audit logs critical to AI operations?",
    "choice_a": "They reduce storage use",
    "choice_b": "They improve inference speed",
    "choice_c": "They ensure integrity and prevent tampering with compliance records",
    "choice_d": "They remove human review",
    "correct_answer": "C",
    "explanation": "Immutable logs preserve trustworthy evidence for audits, investigations, and other matters.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      597,
      213,
      596,
      565,
      595
    ],
    "source": "363940_PracticeTest_01"
  },
  {
    "id": 207,
    "question": "A startup documents which data sources were obtained under license and which were generated internally. What does this satisfy?",
    "choice_a": "Provenance documentation requirement",
    "choice_b": "Fair-use exemption",
    "choice_c": "Quantization record",
    "choice_d": "Model interpretability",
    "correct_answer": "A",
    "explanation": "Provenance tracking confirms lawful collection and licensing of data used for AI training.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      497,
      480,
      496,
      464,
      479
    ],
    "source": "363940_PracticeTest_01"
  },
  {
    "id": 208,
    "question": "A regulator requests an AI system’s model card. What is the purpose of this artifact?",
    "choice_a": "Record employee access",
    "choice_b": "Show server performance",
    "choice_c": "Summarize model purpose, data sources, metrics, and limitations",
    "choice_d": "Document financial forecasts",
    "correct_answer": "C",
    "explanation": "Model cards improve transparency by detailing intended use and key governance parameters.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      606,
      608,
      431,
      597,
      565
    ],
    "source": "363940_PracticeTest_01"
  },
  {
    "id": 209,
    "question": "A company embeds “privacy by design” into its AI development pipeline. What does this achieve?",
    "choice_a": "Compliance with privacy principles from concept through deployment",
    "choice_b": "Lower training cost",
    "choice_c": "Marketing differentiation",
    "choice_d": "Simplified user interface",
    "correct_answer": "A",
    "explanation": "Embedding privacy controls early ensures lawful, transparent processing.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      177,
      181,
      178,
      182,
      192
    ],
    "source": "363940_PracticeTest_01"
  },
  {
    "id": 210,
    "question": "An AI vendor claims its system has “zero bias,” though testing shows otherwise. Which governance gap occurred?",
    "choice_a": "Model overfitting",
    "choice_b": "Vendor drift",
    "choice_c": "Excessive transparency",
    "choice_d": "Absent review of external communications",
    "correct_answer": "D",
    "explanation": "Governance requires pre‐approval of external claims to ensure accuracy. Unsupported “zero bias” claims undermine trust and compliance.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      606,
      278,
      587,
      607,
      431
    ],
    "source": "363940_PracticeTest_01"
  },
  {
    "id": 211,
    "question": "Which U.S. law protects consumer credit data used in automated lending decisions?",
    "choice_a": "FCRA",
    "choice_b": "HIPAA",
    "choice_c": "COPPA",
    "choice_d": "GLBA",
    "correct_answer": "A",
    "explanation": "The Fair Credit Reporting Act (FCRA) governs consumer credit information accuracy and access rights.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      256,
      254,
      275,
      274,
      172
    ],
    "source": "363940_PracticeTest_01"
  },
  {
    "id": 212,
    "question": "The operator of a government-sector AI system is required to provide documentation showing bias testing and risk mitigation. Which framework principle does this reflect?",
    "choice_a": "Data minimization",
    "choice_b": "Proprietary secrecy",
    "choice_c": "Model compression",
    "choice_d": "Transparency and accountability",
    "correct_answer": "D",
    "explanation": "Transparency and accountability ensure that public-sector AI systems are openly documented, explainable, and responsibly governed.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      587,
      606,
      595,
      259,
      596
    ],
    "source": "363940_PracticeTest_01"
  },
  {
    "id": 213,
    "question": "Why should organizations align AI governance reviews with board-level risk reporting?",
    "choice_a": "Eliminates operational audits",
    "choice_b": "Ensures AI risk visibility and strategic accountability",
    "choice_c": "Focuses on model performance only",
    "choice_d": "Reduces transparency",
    "correct_answer": "B",
    "explanation": "Board alignment embeds AI oversight into enterprise-risk governance structures.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      61,
      99,
      117,
      124,
      105
    ],
    "source": "363940_PracticeTest_01"
  },
  {
    "id": 214,
    "question": "An AI monitoring dashboard reveals accuracy degradation. What process should be triggered automatically?",
    "choice_a": "Marketing review",
    "choice_b": "Encryption key renewal",
    "choice_c": "Cost re-forecasting",
    "choice_d": "Retraining or recalibration workflow",
    "correct_answer": "D",
    "explanation": "Continuous monitoring enables timely retraining to maintain reliability.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      547,
      596,
      564,
      616,
      595
    ],
    "source": "363940_PracticeTest_01"
  },
  {
    "id": 215,
    "question": "Which safeguard limits the chance that individual records can be reconstructed from an AI model?",
    "choice_a": "Quantization",
    "choice_b": "Pruning",
    "choice_c": "Differential privacy",
    "choice_d": "Distillation",
    "correct_answer": "C",
    "explanation": "Differential privacy techniques add noise to data or gradients to protect confidentiality.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      577,
      482,
      466,
      519,
      536
    ],
    "source": "363940_PracticeTest_01"
  },
  {
    "id": 216,
    "question": "A university uses an AI system to grade essays, but allows manual re-evaluation upon request. What right does this uphold?",
    "choice_a": "Right to data portability",
    "choice_b": "Right to human review of automated decisions",
    "choice_c": "Right to rectification",
    "choice_d": "Right to restrict processing",
    "correct_answer": "B",
    "explanation": "Individuals can seek human review when AI affects significant outcomes.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      217,
      317,
      210,
      216,
      192
    ],
    "source": "363940_PracticeTest_01"
  },
  {
    "id": 217,
    "question": "An AI system project plan lists fallback procedures to follow if deployments fail. Which governance control does this represent?",
    "choice_a": "Rollback plans",
    "choice_b": "Configuration management",
    "choice_c": "Data minimization",
    "choice_d": "Transparency notice",
    "correct_answer": "A",
    "explanation": "Rollback plans maintain operational resilience and mitigate harm from failed releases.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      546,
      587,
      565,
      548,
      191
    ],
    "source": "363940_PracticeTest_01"
  },
  {
    "id": 218,
    "question": "A model trained on one country’s data performs poorly elsewhere. Which corrective action is most appropriate?",
    "choice_a": "Regional retraining with representative local data",
    "choice_b": "Disable monitoring",
    "choice_c": "Reduce transparency reporting",
    "choice_d": "Compress weights",
    "correct_answer": "A",
    "explanation": "Localization ensures fairness and cultural accuracy across multiple jurisdictions.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      617,
      214,
      259,
      429,
      547
    ],
    "source": "363940_PracticeTest_01"
  },
  {
    "id": 219,
    "question": "Under the EU AI Act, which AI system classification involves minimal documentation and transparency only?",
    "choice_a": "High-risk systems",
    "choice_b": "Prohibited systems",
    "choice_c": "Limited-risk systems",
    "choice_d": "General-purpose AI",
    "correct_answer": "C",
    "explanation": "Limited‐risk AI systems (for example, chatbots) require transparency disclosures but not full conformity assessments. High‐risk systems require extensive documentation and CE marking.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      318,
      312,
      311,
      317,
      316
    ],
    "source": "363940_PracticeTest_01"
  },
  {
    "id": 220,
    "question": "An AI developer forgets to document random-seed settings during training. What governance objective is compromised?",
    "choice_a": "Interpretability",
    "choice_b": "Fairness",
    "choice_c": "Privacy",
    "choice_d": "Reproducibility",
    "correct_answer": "D",
    "explanation": "Without controlled seeds, training results can’t be replicated, undermining auditability.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      404,
      508,
      405,
      505,
      553
    ],
    "source": "363940_PracticeTest_01"
  },
  {
    "id": 221,
    "question": "Which function of the NIST AI RMF measures AI system reliability and bias through metrics?",
    "choice_a": "Map",
    "choice_b": "Measure",
    "choice_c": "Manage",
    "choice_d": "Govern",
    "correct_answer": "B",
    "explanation": "The “Measure” function quantifies risk indicators like accuracy, bias, and robustness.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      352,
      349,
      178,
      374,
      316
    ],
    "source": "363940_PracticeTest_01"
  },
  {
    "id": 222,
    "question": "Why are periodic policy reviews critical for AI ethics programs?",
    "choice_a": "To reflect evolving legal and societal expectations",
    "choice_b": "To shorten project schedules",
    "choice_c": "To reduce transparency",
    "choice_d": "To bypass board approval",
    "correct_answer": "A",
    "explanation": "Continuous review keeps governance frameworks aligned with emerging laws, industry standards, and public expectations.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      117,
      148,
      61,
      124,
      74
    ],
    "source": "363940_PracticeTest_01"
  },
  {
    "id": 223,
    "question": "A developer adds new unvetted public data to a production model. Which governance safeguard was missing?",
    "choice_a": "Model compression",
    "choice_b": "Edge-deployment control",
    "choice_c": "Data labeling",
    "choice_d": "Change-management and data-approval workflow",
    "correct_answer": "D",
    "explanation": "Governance mandates a formal review before modifying live model training data.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      465,
      482,
      464,
      479,
      467
    ],
    "source": "363940_PracticeTest_01"
  },
  {
    "id": 224,
    "question": "An organization identifies bias incidents repeating across projects. What long-term improvement process applies?",
    "choice_a": "Root cause analysis and policy refinement",
    "choice_b": "Dataset expansion only",
    "choice_c": "Model quantization",
    "choice_d": "Elimination of audits",
    "correct_answer": "A",
    "explanation": "Root cause analysis and reviews feed lessons into policy and process updates.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      595,
      596,
      259,
      565,
      547
    ],
    "source": "363940_PracticeTest_01"
  },
  {
    "id": 225,
    "question": "Which ISO standard provides AI risk-management guidance complementing governance frameworks?",
    "choice_a": "ISO/IEC 23894",
    "choice_b": "ISO/IEC 27017",
    "choice_c": "ISO 9004",
    "choice_d": "ISO 31000",
    "correct_answer": "A",
    "explanation": "ISO/IEC 23894 (“Information technology—Artificial intelligence—Guidance on risk management”) outlines principles for managing AI-specific risks.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      384,
      382,
      349,
      381,
      354
    ],
    "source": "363940_PracticeTest_01"
  },
  {
    "id": 226,
    "question": "A model trained on unbalanced data overestimates one class outcome. What corrective step aligns with fairness governance?",
    "choice_a": "Increase compute nodes",
    "choice_b": "Rebalance the dataset and re-evaluate metrics",
    "choice_c": "Remove monitoring",
    "choice_d": "Skip validation",
    "correct_answer": "B",
    "explanation": "Balancing datasets and validating subgroup performance mitigates bias.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      520,
      507,
      481,
      554,
      444
    ],
    "source": "363940_PracticeTest_01"
  },
  {
    "id": 227,
    "question": "An AI product passes security checks but lacks documentation of risk acceptance. What assurance gap remains?",
    "choice_a": "Accountability for residual risk",
    "choice_b": "Hardware certification",
    "choice_c": "Legal indemnity",
    "choice_d": "Vendor audit",
    "correct_answer": "A",
    "explanation": "Governance requires documentation of explicit acknowledgment and approval of accepted risks.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      595,
      565,
      431,
      596,
      430
    ],
    "source": "363940_PracticeTest_01"
  },
  {
    "id": 228,
    "question": "Which U.S. law restricts financial institutions’ sharing of consumer data with third parties?",
    "choice_a": "COPPA",
    "choice_b": "HIPAA",
    "choice_c": "ECOA",
    "choice_d": "GLBA",
    "correct_answer": "D",
    "explanation": "The Gramm-Leach-Bliley Act (GLBA) governs consumer financial privacy obligations.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      274,
      277,
      322,
      256,
      316
    ],
    "source": "363940_PracticeTest_01"
  },
  {
    "id": 229,
    "question": "A compliance team maps AI systems against all applicable regional laws. What is this process called?",
    "choice_a": "Vendor assessment",
    "choice_b": "Adversarial testing",
    "choice_c": "Data annotation",
    "choice_d": "Regulatory mapping",
    "correct_answer": "D",
    "explanation": "Regulatory mapping identifies governing laws and obligations by jurisdiction.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      565,
      427,
      597,
      259,
      607
    ],
    "source": "363940_PracticeTest_01"
  },
  {
    "id": 230,
    "question": "An AI system stores raw user data indefinitely. Which privacy principle is violated?",
    "choice_a": "Accuracy",
    "choice_b": "Fairness",
    "choice_c": "Storage limitation",
    "choice_d": "Interoperability",
    "correct_answer": "C",
    "explanation": "The principle of storage limitation requires that personal data be retained only for as long as necessary for its purpose.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      176,
      181,
      177,
      216,
      182
    ],
    "source": "363940_PracticeTest_01"
  },
  {
    "id": 231,
    "question": "Why would a firm’s AI audit include interviews with engineers, risk officers, and executives?",
    "choice_a": "To assess marketing efficiency",
    "choice_b": "To test latency",
    "choice_c": "To validate the implementation of AI governance across functions",
    "choice_d": "To review syntax errors",
    "correct_answer": "C",
    "explanation": "Multidisciplinary interviews verify the integration of AI governance and accountability and corroborate written procedures and records.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      548,
      565,
      596,
      546,
      595
    ],
    "source": "363940_PracticeTest_01"
  },
  {
    "id": 232,
    "question": "A company retires an obsolete AI chatbot. Why would it retain its source code and logs?",
    "choice_a": "To reduce energy cost",
    "choice_b": "To retrain without approval",
    "choice_c": "To obscure decisions",
    "choice_d": "To preserve evidence for audit, accountability, and compliance verification",
    "correct_answer": "D",
    "explanation": "Retaining lifecycle artifacts supports accountability and post-decommissioning reviews.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      618,
      616,
      596,
      597,
      565
    ],
    "source": "363940_PracticeTest_01"
  },
  {
    "id": 233,
    "question": "What distinguishes concept drift from data drift?",
    "choice_a": "Concept drift affects compute usage",
    "choice_b": "Data drift alters code logic",
    "choice_c": "Concept drift changes input-output relationships; data drift changes input distribution",
    "choice_d": "They are identical",
    "correct_answer": "C",
    "explanation": "Concept drift occurs when the statistical relationship between inputs and outputs changes because of real-world shifts, leading the model’s predictions to become less accurate. Data drift occurs when the distribution of input data changes over time, even if the underlying relationships remain the same. Detecting both types of drift is vital for maintaining AI reliability and fairness.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      554,
      519,
      481,
      521,
      553
    ],
    "source": "363940_PracticeTest_01"
  },
  {
    "id": 234,
    "question": "A hospital uses AI to interpret imaging data. Which oversight model ensures patient safety?",
    "choice_a": "Human-in-the-loop",
    "choice_b": "Autonomous",
    "choice_c": "Human-out-of-loop",
    "choice_d": "Shadow-mode",
    "correct_answer": "A",
    "explanation": "Human review of diagnostic AI output ensures accountability in clinical decisions.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      430,
      259,
      427,
      565,
      596
    ],
    "source": "363940_PracticeTest_01"
  },
  {
    "id": 235,
    "question": "Which NIST AI RMF function focuses on executing mitigations and monitoring over time?",
    "choice_a": "Govern",
    "choice_b": "Map",
    "choice_c": "Manage",
    "choice_d": "Measure",
    "correct_answer": "C",
    "explanation": "The “Manage” function in NIST AI RMF (National Institute of Standards and Technology AI Risk Management Framework) operationalizes risk responses and continuous improvement.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      353,
      349,
      352,
      354,
      178
    ],
    "source": "363940_PracticeTest_01"
  },
  {
    "id": 236,
    "question": "A marketing team promotes an AI system before bias testing is complete. What should governance require?",
    "choice_a": "Release disclaimers later",
    "choice_b": "Delay publication until validation and approval",
    "choice_c": "Outsource risk review",
    "choice_d": "Proceed under fair-use",
    "correct_answer": "B",
    "explanation": "Oversight ensures no external claims are made before testing confirms compliance.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      546,
      278,
      431,
      606,
      259
    ],
    "source": "363940_PracticeTest_01"
  },
  {
    "id": 237,
    "question": "Why do fairness audits include metrics in addition to accuracy?",
    "choice_a": "To reduce compute load",
    "choice_b": "To test latency",
    "choice_c": "To detect subgroup disparities not visible in aggregate accuracy",
    "choice_d": "To anonymize input data",
    "correct_answer": "C",
    "explanation": "Broader metrics reveal discriminatory patterns hidden by overall performance scores.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      520,
      507,
      522,
      554,
      505
    ],
    "source": "363940_PracticeTest_01"
  },
  {
    "id": 238,
    "question": "A developer removes historical data that caused bias in training. Which fairness mitigation technique is this?",
    "choice_a": "Dataset rebalancing",
    "choice_b": "Quantization",
    "choice_c": "Model distillation",
    "choice_d": "Feature hashing",
    "correct_answer": "A",
    "explanation": "Rebalancing or resampling corrects skewed data representation across groups.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      520,
      507,
      522,
      575,
      554
    ],
    "source": "363940_PracticeTest_01"
  },
  {
    "id": 239,
    "question": "An AI vendor integrates its risk register with enterprise GRC software. What benefit results from this?",
    "choice_a": "Unified risk visibility and governance consistency",
    "choice_b": "Increased model latency",
    "choice_c": "Reduced transparency",
    "choice_d": "Higher compute cost",
    "correct_answer": "A",
    "explanation": "Integration aligns AI oversight with enterprise-wide governance frameworks.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      97,
      75,
      61,
      63,
      74
    ],
    "source": "363940_PracticeTest_01"
  },
  {
    "id": 240,
    "question": "A developer documents hyperparameter settings during model training. Why is this important?",
    "choice_a": "Enables reproducibility and validation",
    "choice_b": "Speeds up inference",
    "choice_c": "Ensures fairness",
    "choice_d": "Reduces audit frequency",
    "correct_answer": "A",
    "explanation": "Complete configuration records make experiments verifiable and auditable, and aid in troubleshooting.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      404,
      405,
      403,
      521,
      579
    ],
    "source": "363940_PracticeTest_01"
  },
  {
    "id": 241,
    "question": "A cross-functional team classifies an AI incident as “medium severity.” What should follow?",
    "choice_a": "Public disclosure immediately",
    "choice_b": "Record, assign owner, and initiate proportional mitigation",
    "choice_c": "Ignore minor incidents",
    "choice_d": "Delete related data",
    "correct_answer": "B",
    "explanation": "Governance requires documenting all incidents and managing them by severity, in accordance with a written incident response plan and playbooks.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      595,
      587,
      191,
      596,
      565
    ],
    "source": "363940_PracticeTest_01"
  },
  {
    "id": 242,
    "question": "A startup designs its AI policy to remain “technology-neutral.” What advantage does this provide?",
    "choice_a": "Focuses only on neural networks",
    "choice_b": "Futureproofs policy across evolving AI methods",
    "choice_c": "Reduces explainability",
    "choice_d": "Avoids board oversight",
    "correct_answer": "B",
    "explanation": "Technology-neutral principles remain valid as architectures change.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      117,
      97,
      63,
      148,
      9
    ],
    "source": "363940_PracticeTest_01"
  },
  {
    "id": 243,
    "question": "Under privacy law, which principle limits how long personal data may be retained?",
    "choice_a": "Storage limitation",
    "choice_b": "Accuracy",
    "choice_c": "Accountability",
    "choice_d": "Data minimization",
    "correct_answer": "A",
    "explanation": "According to the principle of storage limitation, data should be kept only for as long as necessary for its stated purpose.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      176,
      177,
      181,
      187,
      316
    ],
    "source": "363940_PracticeTest_01"
  },
  {
    "id": 244,
    "question": "An AI model misclassifies images when lighting changes. Which testing technique would reveal this?",
    "choice_a": "Edge-case and adversarial testing",
    "choice_b": "Quantization testing",
    "choice_c": "Model stacking",
    "choice_d": "Transfer learning",
    "correct_answer": "A",
    "explanation": "Edge-case testing ensures robustness to unusual real-world inputs.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      564,
      565,
      595,
      429,
      427
    ],
    "source": "363940_PracticeTest_01"
  },
  {
    "id": 245,
    "question": "A finance AI uses historical data that reflects redlining practices. Which ethical issue arises?",
    "choice_a": "Over-regularization",
    "choice_b": "Data drift",
    "choice_c": "Embedded historical bias",
    "choice_d": "Privacy by design",
    "correct_answer": "C",
    "explanation": "Historical discrimination encoded in data must be mitigated through fairness testing.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      214,
      429,
      259,
      547,
      596
    ],
    "source": "363940_PracticeTest_01"
  },
  {
    "id": 246,
    "question": "Which ISO standard establishes a certifiable management system specifically for AI?",
    "choice_a": "ISO/IEC 22989",
    "choice_b": "ISO 31000",
    "choice_c": "ISO/IEC 42001",
    "choice_d": "ISO 9001",
    "correct_answer": "C",
    "explanation": "ISO/IEC 42001 (“Information technology—Artificial intelligence—Management system”) establishes requirements for an auditable AI management system.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      382,
      383,
      384,
      381,
      354
    ],
    "source": "363940_PracticeTest_01"
  },
  {
    "id": 247,
    "question": "Why should vendors disclose data lineage for third-party models?",
    "choice_a": "To boost computational efficiency",
    "choice_b": "To avoid conformity assessment",
    "choice_c": "To protect IP secrecy",
    "choice_d": "To verify lawful sourcing and assess bias risk",
    "correct_answer": "D",
    "explanation": "Transparency of training data underpins contractual and ethical accountability.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      120,
      157,
      159,
      160,
      39
    ],
    "source": "363940_PracticeTest_01"
  },
  {
    "id": 248,
    "question": "Which U.S. statute limits discrimination in housing or lending decisions by AI systems?",
    "choice_a": "HIPAA",
    "choice_b": "COPPA",
    "choice_c": "GLBA",
    "choice_d": "Fair Housing Act",
    "correct_answer": "D",
    "explanation": "The Fair Housing Act prohibits disparate-impact bias in housing-related decisions.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      257,
      254,
      256,
      274,
      211
    ],
    "source": "363940_PracticeTest_01"
  },
  {
    "id": 249,
    "question": "A model deployed globally must comply with regional privacy and cultural norms. Which governance control applies?",
    "choice_a": "Quantization",
    "choice_b": "Distillation",
    "choice_c": "Localization strategy",
    "choice_d": "Regularization",
    "correct_answer": "C",
    "explanation": "Localization retrains or adjusts models per region to meet legal and societal expectations.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      617,
      565,
      427,
      431,
      607
    ],
    "source": "363940_PracticeTest_01"
  },
  {
    "id": 250,
    "question": "An organization classifies each AI system by potential impact on individuals. What framework step is this?",
    "choice_a": "Conformity assessment",
    "choice_b": "Data labeling",
    "choice_c": "Incident escalation",
    "choice_d": "Risk mapping",
    "correct_answer": "D",
    "explanation": "Mapping systems by risk ensures proportional governance and compliance actions.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      349,
      350,
      311,
      382,
      354
    ],
    "source": "363940_PracticeTest_01"
  },
  {
    "id": 251,
    "question": "A firm implements immutable, append-only logs for AI outputs. What governance principle does this fulfill?",
    "choice_a": "Efficiency",
    "choice_b": "Traceability",
    "choice_c": "Fairness",
    "choice_d": "Nonrepudiation",
    "correct_answer": "B",
    "explanation": "Traceability ensures the auditability of decisions and the integrity of evidence.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      597,
      596,
      565,
      546,
      587
    ],
    "source": "363940_PracticeTest_01"
  },
  {
    "id": 252,
    "question": "An AI application predicts employee performance and triggers management decisions. What safeguard should exist?",
    "choice_a": "Automated approval only",
    "choice_b": "Public disclosure of code",
    "choice_c": "Random data sampling",
    "choice_d": "Human-in-command review for consequential employment actions",
    "correct_answer": "D",
    "explanation": "AI systems used in employment decision-making are considered high-impact or high-risk and require human oversight to ensure fairness, accountability, and compliance with labor and anti-discrimination laws.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      259,
      430,
      427,
      428,
      431
    ],
    "source": "363940_PracticeTest_01"
  },
  {
    "id": 253,
    "question": "A dataset includes personal identifiers not needed for training. Which privacy principle is violated?",
    "choice_a": "Integrity",
    "choice_b": "Availability",
    "choice_c": "Data minimization",
    "choice_d": "Accuracy",
    "correct_answer": "C",
    "explanation": "The principle of data minimization directs data collection to what is strictly necessary for processing.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      176,
      181,
      177,
      178,
      187
    ],
    "source": "363940_PracticeTest_01"
  },
  {
    "id": 254,
    "question": "Why are after-action reviews (AARs) valuable after AI decommissioning?",
    "choice_a": "They capture lessons learned for process improvement",
    "choice_b": "They remove old logs",
    "choice_c": "They reduce latency",
    "choice_d": "They accelerate retraining",
    "correct_answer": "A",
    "explanation": "AARs identify improvements for future lifecycle governance.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      616,
      618,
      617,
      565,
      595
    ],
    "source": "363940_PracticeTest_01"
  },
  {
    "id": 255,
    "question": "A company compares AI system risks against business KPIs. Which practice is this?",
    "choice_a": "Isolated AI auditing",
    "choice_b": "Automated risk scoring",
    "choice_c": "Training optimization",
    "choice_d": "Integrating AI risk with enterprise-performance management",
    "correct_answer": "D",
    "explanation": "Linking risks to KPIs embeds AI oversight within strategic governance.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      565,
      548,
      597,
      7,
      595
    ],
    "source": "363940_PracticeTest_01"
  },
  {
    "id": 256,
    "question": "Why must AI governance include post-market monitoring plans?",
    "choice_a": "To reduce regulation",
    "choice_b": "To avoid retraining",
    "choice_c": "To verify continued safety, accuracy, and fairness after release",
    "choice_d": "To shift liability",
    "correct_answer": "C",
    "explanation": "Continuous monitoring ensures AI performance and compliance over time.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      596,
      547,
      278,
      595,
      431
    ],
    "source": "363940_PracticeTest_01"
  },
  {
    "id": 257,
    "question": "Why is AI governance necessary even in low-risk applications?",
    "choice_a": "It prevents all errors",
    "choice_b": "It ensures proportional oversight and documentation",
    "choice_c": "It replaces testing",
    "choice_d": "It guarantees profitability",
    "correct_answer": "B",
    "explanation": "Governance applies across all risk levels to maintain transparency and proportional accountability.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      99,
      124,
      117,
      42,
      60
    ],
    "source": "363940_PracticeTest_02"
  },
  {
    "id": 258,
    "question": "Which factor most strengthens public trust in AI?",
    "choice_a": "Model opacity",
    "choice_b": "Rapid deployment",
    "choice_c": "Consistent transparency reporting",
    "choice_d": "Vendor exclusivity",
    "correct_answer": "C",
    "explanation": "Transparent disclosure of model behavior and limits builds stakeholder confidence and public trust.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      606,
      587,
      608,
      607,
      278
    ],
    "source": "363940_PracticeTest_02"
  },
  {
    "id": 259,
    "question": "A company conducts stakeholder workshops on AI ethics. Which principle is being applied?",
    "choice_a": "Fairness",
    "choice_b": "Efficiency",
    "choice_c": "Participatory governance",
    "choice_d": "Automation",
    "correct_answer": "C",
    "explanation": "Engaging stakeholders supports inclusiveness and ethical legitimacy of AI decisions.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      75,
      62,
      42,
      60,
      87
    ],
    "source": "363940_PracticeTest_02"
  },
  {
    "id": 260,
    "question": "Which scenario best illustrates accountability in AI governance?",
    "choice_a": "Named owners responsible for AI outcomes",
    "choice_b": "Anonymous teams building models",
    "choice_c": "Open-source licensing",
    "choice_d": "Continuous integration",
    "correct_answer": "A",
    "explanation": "Clear responsibility lines ensure traceability, transparency, and corrective capability.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      60,
      42,
      63,
      61,
      103
    ],
    "source": "363940_PracticeTest_02"
  },
  {
    "id": 261,
    "question": "What distinguishes mature AI governance programs from ad hoc efforts?",
    "choice_a": "Single developer oversight",
    "choice_b": "Unwritten procedures",
    "choice_c": "Vendor-only controls",
    "choice_d": "Formalized roles, metrics, and continuous improvement",
    "correct_answer": "D",
    "explanation": "Maturity entails structured management, regular review, defined accountability, and continuous improvement.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      97,
      60,
      89,
      117,
      124
    ],
    "source": "363940_PracticeTest_02"
  },
  {
    "id": 262,
    "question": "Which AI governance model ensures shared accountability across business units?",
    "choice_a": "Centralized governance only",
    "choice_b": "Outsourced governance",
    "choice_c": "Reactive oversight",
    "choice_d": "Federated governance model",
    "correct_answer": "D",
    "explanation": "Federated models assign coordinated responsibility between business units and central authority.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      60,
      105,
      63,
      75,
      103
    ],
    "source": "363940_PracticeTest_02"
  },
  {
    "id": 263,
    "question": "Why should AI governance frameworks include escalation procedures?",
    "choice_a": "To increase bureaucracy",
    "choice_b": "To slow deployment",
    "choice_c": "To limit transparency",
    "choice_d": "To manage incidents and disagreements efficiently",
    "correct_answer": "D",
    "explanation": "Defined escalation ensures timely risk and incident resolution, as well as accountability.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      125,
      42,
      60,
      103,
      61
    ],
    "source": "363940_PracticeTest_02"
  },
  {
    "id": 264,
    "question": "A risk committee reviews quarterly AI-related metrics. What governance activity is this?",
    "choice_a": "Vendor contracting",
    "choice_b": "Training optimization",
    "choice_c": "Performance monitoring within a maturity model",
    "choice_d": "Incident avoidance",
    "correct_answer": "C",
    "explanation": "Regular measurement demonstrates a managed, repeatable governance process.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      97,
      123,
      89,
      63,
      99
    ],
    "source": "363940_PracticeTest_02"
  },
  {
    "id": 265,
    "question": "Why must vendor contracts specify training-data provenance?",
    "choice_a": "To speed up delivery",
    "choice_b": "To lower compute cost",
    "choice_c": "To verify lawful use and reduce IP or privacy risk",
    "choice_d": "To meet performance KPIs",
    "correct_answer": "C",
    "explanation": "Including training-data provenance clauses in vendor contracts ensures that all data used in model development is lawfully obtained, ethically sourced, and properly licensed.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      120,
      159,
      31,
      157,
      160
    ],
    "source": "363940_PracticeTest_02"
  },
  {
    "id": 266,
    "question": "An organization adds AI clauses to its procurement policy. What improvements are likely to result?",
    "choice_a": "Integration of AI compliance into purchasing workflows",
    "choice_b": "Faster invoice approval",
    "choice_c": "Reduced staff training",
    "choice_d": "Elimination of audits",
    "correct_answer": "A",
    "explanation": "AI procurement clauses embed AI governance expectations into vendor selection, ensuring that procured AI systems comply with requirements and applicable laws.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      158,
      159,
      157,
      148,
      117
    ],
    "source": "363940_PracticeTest_02"
  },
  {
    "id": 267,
    "question": "A model uses publicly scraped data containing personal information. Which step ensures legality?",
    "choice_a": "Encrypting model weights only",
    "choice_b": "Verifying consent or removing sensitive data before use",
    "choice_c": "Reducing the dataset size",
    "choice_d": "Increasing batch size",
    "correct_answer": "B",
    "explanation": "Validating lawful basis and consent prevents privacy-law violations.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      120,
      31,
      147,
      40,
      146
    ],
    "source": "363940_PracticeTest_02"
  },
  {
    "id": 268,
    "question": "Which privacy principle requires limiting data collection to necessary fields?",
    "choice_a": "Accountability",
    "choice_b": "Integrity",
    "choice_c": "Accuracy",
    "choice_d": "Data minimization",
    "correct_answer": "D",
    "explanation": "Data minimization mandates collecting only what is essential for the stated purpose.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      176,
      181,
      177,
      173,
      187
    ],
    "source": "363940_PracticeTest_02"
  },
  {
    "id": 269,
    "question": "Why are Data Protection Impact Assessments (DPIAs) important for AI?",
    "choice_a": "They measure algorithmic accuracy",
    "choice_b": "They certify ISO compliance",
    "choice_c": "They identify privacy risks before deployment",
    "choice_d": "They replace audits",
    "correct_answer": "C",
    "explanation": "DPIAs evaluate potential harms and guide mitigation planning and are required for high-risk AI systems by the EU AI Act.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      187,
      316,
      177,
      311,
      216
    ],
    "source": "363940_PracticeTest_02"
  },
  {
    "id": 270,
    "question": "Which right allows individuals to challenge automated AI decisions?",
    "choice_a": "Right to review/contest",
    "choice_b": "Right to portability",
    "choice_c": "Right to data minimization",
    "choice_d": "Right to rectification",
    "correct_answer": "A",
    "explanation": "Data-protection laws grant individuals the ability to seek human review.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      217,
      210,
      216,
      316,
      187
    ],
    "source": "363940_PracticeTest_02"
  },
  {
    "id": 271,
    "question": "Which U.S. regulation prohibits discriminatory lending, including by AI systems?",
    "choice_a": "ECOA",
    "choice_b": "HIPAA",
    "choice_c": "COPPA",
    "choice_d": "FCRA",
    "correct_answer": "A",
    "explanation": "The Equal Credit Opportunity Act (ECOA) forbids bias in credit-related decisions.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      256,
      254,
      274,
      275,
      255
    ],
    "source": "363940_PracticeTest_02"
  },
  {
    "id": 272,
    "question": "An AI recruiting tool excludes older applicants. Which legal issue arises?",
    "choice_a": "Trade-secret misuse",
    "choice_b": "Model theft",
    "choice_c": "Age discrimination",
    "choice_d": "Latency failure",
    "correct_answer": "C",
    "explanation": "Employment law prohibits discrimination on protected attributes such as age.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      255,
      254,
      211
    ],
    "source": "363940_PracticeTest_02"
  },
  {
    "id": 273,
    "question": "What type of AI practice is prohibited under the EU AI Act?",
    "choice_a": "Weather forecasting",
    "choice_b": "Medical-device calibration",
    "choice_c": "Social scoring of individuals by governments",
    "choice_d": "Chatbots with disclaimers",
    "correct_answer": "C",
    "explanation": "Prohibited AI includes manipulative or fundamental rights-violating applications.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      311,
      276,
      277,
      316,
      345
    ],
    "source": "363940_PracticeTest_02"
  },
  {
    "id": 274,
    "question": "High-risk AI systems in the EU must maintain which records?",
    "choice_a": "Marketing plan",
    "choice_b": "Training-data license",
    "choice_c": "Corporate audit letter",
    "choice_d": "Technical documentation for conformity assessment",
    "correct_answer": "D",
    "explanation": "Detailed technical files demonstrate compliance readiness under the EU AI Act.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      316,
      317,
      311,
      192,
      337
    ],
    "source": "363940_PracticeTest_02"
  },
  {
    "id": 275,
    "question": "Why does the NIST AI RMF begin with the “Map” function?",
    "choice_a": "To collect metrics",
    "choice_b": "To execute mitigation plans",
    "choice_c": "To perform audits",
    "choice_d": "To understand context, purpose, and stakeholders",
    "correct_answer": "D",
    "explanation": "Mapping defines how AI interacts with its environment and the risks it faces.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      351,
      349,
      354,
      350,
      178
    ],
    "source": "363940_PracticeTest_02"
  },
  {
    "id": 276,
    "question": "Which ISO standard defines a common vocabulary for AI concepts?",
    "choice_a": "ISO/IEC 42001",
    "choice_b": "ISO 9001",
    "choice_c": "ISO/IEC 27017",
    "choice_d": "ISO/IEC 22989",
    "correct_answer": "D",
    "explanation": "ISO/IEC 22989 (“Information technology—Artificial intelligence—Artificial intelligence concepts and terminology”) provides harmonized terminology to align governance efforts.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      381,
      384,
      395,
      382,
      345
    ],
    "source": "363940_PracticeTest_02"
  },
  {
    "id": 277,
    "question": "Why should explainability testing occur early in AI design?",
    "choice_a": "To improve speed",
    "choice_b": "To anonymize data",
    "choice_c": "To ensure interpretability before deployment",
    "choice_d": "To compress models",
    "correct_answer": "C",
    "explanation": "Explainability-by-design ensures the resulting AI model will be more effective and transparent.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      465,
      507,
      522,
      442,
      521
    ],
    "source": "363940_PracticeTest_02"
  },
  {
    "id": 278,
    "question": "A team documents model architecture, data flow, and validation results. What governance requirement does this meet?",
    "choice_a": "Marketing review",
    "choice_b": "Bias mitigation only",
    "choice_c": "Lifecycle documentation for accountability",
    "choice_d": "Model scaling",
    "correct_answer": "C",
    "explanation": "Comprehensive documentation supports accountability, reproducibility, and effective oversight.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      403,
      579,
      405,
      404,
      508
    ],
    "source": "363940_PracticeTest_02"
  },
  {
    "id": 279,
    "question": "A model trained in one country fails in another. Which concept explains this?",
    "choice_a": "Compression loss",
    "choice_b": "Concept drift due to contextual differences",
    "choice_c": "Hardware dependency",
    "choice_d": "Data minimization",
    "correct_answer": "B",
    "explanation": "Changes in environments alter data relationships, leading to drift, bias, or incorrect results. This failure is more accurately a geographic bias or domain shift.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      554,
      519,
      481,
      521,
      507
    ],
    "source": "363940_PracticeTest_02"
  },
  {
    "id": 280,
    "question": "Why should AI developers record hyperparameter settings?",
    "choice_a": "For encryption keys",
    "choice_b": "For marketing statistics",
    "choice_c": "For model compression",
    "choice_d": "For reproducibility and traceability in audits",
    "correct_answer": "D",
    "explanation": "Parameter logs allow verifiable AI system behavior and aid in troubleshooting and rollbacks.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      405,
      579,
      553,
      404,
      496
    ],
    "source": "363940_PracticeTest_02"
  },
  {
    "id": 281,
    "question": "Which deployment safeguard prevents unsafe updates to production AI systems?",
    "choice_a": "Data compression",
    "choice_b": "Edge inference",
    "choice_c": "Change-management and approval workflow",
    "choice_d": "Configuration management",
    "correct_answer": "C",
    "explanation": "Controlled change-management processes maintain reliability, traceability, and management control.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      546,
      565,
      547,
      597,
      431
    ],
    "source": "363940_PracticeTest_02"
  },
  {
    "id": 282,
    "question": "Why should an organization deploy AI systems in shadow mode before going live?",
    "choice_a": "To shorten deployment time",
    "choice_b": "To replace testing",
    "choice_c": "To test accuracy and safety without real-world consequences",
    "choice_d": "To cut documentation",
    "correct_answer": "C",
    "explanation": "Shadow-mode deployment, which is similar to parallel testing in IT disaster recovery, validates performance while isolating risk from live operations.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      546,
      547,
      548,
      427,
      430
    ],
    "source": "363940_PracticeTest_02"
  },
  {
    "id": 283,
    "question": "A manufacturer’s AI vision system misclassifies rare defects. Which testing method should have detected this?",
    "choice_a": "Random resampling",
    "choice_b": "Model quantization",
    "choice_c": "Edge-case and adversarial testing",
    "choice_d": "Feature pruning",
    "correct_answer": "C",
    "explanation": "Edge-case tests reveal performance weaknesses in uncommon conditions.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      575,
      452,
      507,
      451,
      519
    ],
    "source": "363940_PracticeTest_02"
  },
  {
    "id": 284,
    "question": "A firm maintains immutable audit logs of all AI predictions. What governance objective is served?",
    "choice_a": "Latency reduction",
    "choice_b": "Data minimization",
    "choice_c": "Traceability and accountability",
    "choice_d": "Cost optimization",
    "correct_answer": "C",
    "explanation": "Immutable logs ensure verifiable records for audits and incident reviews.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      597,
      596,
      595,
      565,
      213
    ],
    "source": "363940_PracticeTest_02"
  },
  {
    "id": 285,
    "question": "Why should AI risk registers link each risk to a control owner?",
    "choice_a": "To enable anonymous reporting",
    "choice_b": "To meet marketing objectives",
    "choice_c": "To simplify procurement",
    "choice_d": "To ensure accountability for mitigation and review",
    "correct_answer": "D",
    "explanation": "Assigning owners guarantees accountability and continuous risk management and strengthens the governance chain of responsibility.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      565,
      596,
      595,
      431,
      548
    ],
    "source": "363940_PracticeTest_02"
  },
  {
    "id": 286,
    "question": "A high-risk AI system fails a conformity audit. What must occur before relaunch?",
    "choice_a": "Immediate remarketing",
    "choice_b": "Deletion of audit records",
    "choice_c": "Automatic approval",
    "choice_d": "Remediation of findings and reassessment",
    "correct_answer": "D",
    "explanation": "Non-conformities must be corrected and validated before operation resumes.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      317,
      311,
      316,
      353,
      352
    ],
    "source": "363940_PracticeTest_02"
  },
  {
    "id": 287,
    "question": "A retailer applies AI to recommend children’s toys based on browsing data. Which U.S. law limits this?",
    "choice_a": "ECOA",
    "choice_b": "FCRA",
    "choice_c": "HIPAA",
    "choice_d": "COPPA",
    "correct_answer": "D",
    "explanation": "COPPA (Children’s Online Privacy Protection Act) governs data collected from or about children under 13 years of age.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      275,
      274,
      176,
      187,
      212
    ],
    "source": "363940_PracticeTest_02"
  },
  {
    "id": 288,
    "question": "Which control ensures AI changes can be rolled back safely?",
    "choice_a": "Automatic scaling",
    "choice_b": "Model stacking",
    "choice_c": "Vendor attestation",
    "choice_d": "Version control and deployment approval",
    "correct_answer": "D",
    "explanation": "Versioning preserves stable baselines for rollback in the event of failures.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      546,
      547,
      596,
      565,
      597
    ],
    "source": "363940_PracticeTest_02"
  },
  {
    "id": 289,
    "question": "A company’s AI policy requires annual board approval. What maturity level does this reflect?",
    "choice_a": "Initial",
    "choice_b": "Opportunistic",
    "choice_c": "Defined and managed governance",
    "choice_d": "Experimental",
    "correct_answer": "C",
    "explanation": "Regular high-level oversight indicates structured, mature governance.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      61,
      97,
      60,
      75,
      117
    ],
    "source": "363940_PracticeTest_02"
  },
  {
    "id": 290,
    "question": "A startup shares training data publicly to improve transparency but exposes private information. Which principle was neglected?",
    "choice_a": "Open-data collaboration",
    "choice_b": "Security-through-obscurity",
    "choice_c": "Privacy protection and lawful disclosure",
    "choice_d": "Algorithmic fairness",
    "correct_answer": "C",
    "explanation": "Transparency must not override confidentiality and privacy obligations; it must be balanced with them.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      177,
      181,
      187,
      207,
      178
    ],
    "source": "363940_PracticeTest_02"
  },
  {
    "id": 291,
    "question": "An AI used in healthcare predicts patient outcomes. Which oversight model must apply?",
    "choice_a": "Fully autonomous approval",
    "choice_b": "Human-out-of-loop",
    "choice_c": "Human-in-the-loop review",
    "choice_d": "Self-certified release",
    "correct_answer": "C",
    "explanation": "Medical AI decisions require human-in-the loop clinician confirmation for safety and accountability.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      430,
      259,
      547,
      431,
      427
    ],
    "source": "363940_PracticeTest_02"
  },
  {
    "id": 292,
    "question": "Which practice demonstrates compliance with privacy-by-design?",
    "choice_a": "Encrypting data after deployment only",
    "choice_b": "Integrating data-minimization and access controls from inception",
    "choice_c": "Outsourcing compliance",
    "choice_d": "Collecting data first, anonymizing later",
    "correct_answer": "B",
    "explanation": "Privacy-by-design embeds privacy safeguards at every lifecycle stage.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      177,
      181,
      176,
      178,
      187
    ],
    "source": "363940_PracticeTest_02"
  },
  {
    "id": 293,
    "question": "A firm adopts the NIST AI RMF and ISO/IEC 42001 together. Why?",
    "choice_a": "To duplicate audit work",
    "choice_b": "To replace conformity assessments",
    "choice_c": "To combine voluntary guidance with certifiable governance",
    "choice_d": "To bypass risk analysis",
    "correct_answer": "C",
    "explanation": "The two frameworks complement each other: one is flexible, the other certifiable.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      382,
      349,
      354,
      384,
      383
    ],
    "source": "363940_PracticeTest_02"
  },
  {
    "id": 294,
    "question": "An AI policy defines who can authorize data sharing. What governance control is this?",
    "choice_a": "Model explainability",
    "choice_b": "Role-based accountability",
    "choice_c": "Audit sampling",
    "choice_d": "Technical standardization",
    "correct_answer": "B",
    "explanation": "Defining authority for data-related decisions enforces accountability.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      60,
      103,
      105,
      42,
      104
    ],
    "source": "363940_PracticeTest_02"
  },
  {
    "id": 295,
    "question": "Why is traceability essential in AI lifecycle documentation?",
    "choice_a": "It increases performance speed",
    "choice_b": "It enables anonymization",
    "choice_c": "It hides errors",
    "choice_d": "It allows auditors and stakeholders to verify data origins and decision paths",
    "correct_answer": "D",
    "explanation": "Traceability links datasets, models, and outputs for reliable oversight and issue troubleshooting.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      405,
      496,
      497,
      579,
      498
    ],
    "source": "363940_PracticeTest_02"
  },
  {
    "id": 296,
    "question": "An AI legal-advice app launches without disclaimers. What governance failure occurred?",
    "choice_a": "Lack of transparency to users",
    "choice_b": "Excessive documentation",
    "choice_c": "Over-testing",
    "choice_d": "Algorithm simplification",
    "correct_answer": "A",
    "explanation": "Transparency requires clear disclosure when advice is AI-generated.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      608,
      606,
      278,
      548
    ],
    "source": "363940_PracticeTest_02"
  },
  {
    "id": 297,
    "question": "Why do AI maturity models use staged levels?",
    "choice_a": "To benchmark progress from ad hoc to optimized governance",
    "choice_b": "To assign blame",
    "choice_c": "To replace audits",
    "choice_d": "To certify compliance automatically",
    "correct_answer": "A",
    "explanation": "Maturity models measure the development of governance capability over time, permitting organizations to observe progress as they ascend from one level to the next.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      97,
      117,
      96,
      100,
      75
    ],
    "source": "363940_PracticeTest_02"
  },
  {
    "id": 298,
    "question": "Under the EU AI Act, who must ensure post-market monitoring?",
    "choice_a": "Each end user",
    "choice_b": "National data-protection authority",
    "choice_c": "The provider of the high-risk system",
    "choice_d": "Independent journalists",
    "correct_answer": "C",
    "explanation": "Providers of high-risk AI systems maintain post-market surveillance for ongoing compliance.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      337,
      316,
      299,
      317,
      311
    ],
    "source": "363940_PracticeTest_02"
  },
  {
    "id": 299,
    "question": "A financial AI uses incomplete training data and misprices loans. Which governance domain applies?",
    "choice_a": "Marketing controls",
    "choice_b": "Quantization testing",
    "choice_c": "Access control",
    "choice_d": "Data quality management",
    "correct_answer": "D",
    "explanation": "Ensuring accurate, complete training data prevents biased or unreliable outputs.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      481,
      464,
      479,
      404,
      520
    ],
    "source": "363940_PracticeTest_02"
  },
  {
    "id": 300,
    "question": "Which U.S. law applies when a school’s AI system tracks student performance data?",
    "choice_a": "COPPA",
    "choice_b": "FERPA",
    "choice_c": "ECOA",
    "choice_d": "HIPAA",
    "correct_answer": "B",
    "explanation": "FERPA (Family Educational Rights and Privacy Act) governs the privacy and use of educational records.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      181,
      177,
      274,
      207,
      176
    ],
    "source": "363940_PracticeTest_02"
  },
  {
    "id": 301,
    "question": "A model trained on biased historical data continues to replicate discrimination. Which corrective step is required?",
    "choice_a": "Encrypt logs",
    "choice_b": "Publish weights",
    "choice_c": "Reduce training epochs",
    "choice_d": "Bias audit and dataset remediation",
    "correct_answer": "D",
    "explanation": "Governance mandates re-evaluating and balancing biased training data when AI systems continue to exhibit bias.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      520,
      507,
      481,
      579,
      554
    ],
    "source": "363940_PracticeTest_02"
  },
  {
    "id": 302,
    "question": "Why should a post-deployment AI monitoring dashboard include fairness metrics?",
    "choice_a": "To track compute utilization",
    "choice_b": "To monitor cost",
    "choice_c": "To detect bias drift over time",
    "choice_d": "To replace explainability",
    "correct_answer": "C",
    "explanation": "Including fairness metrics in a post-deployment monitoring dashboard enables continuous detection of bias drift; changes in model behavior that may disadvantage certain groups as data or environments evolve.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      547,
      596,
      429,
      214,
      278
    ],
    "source": "363940_PracticeTest_02"
  },
  {
    "id": 303,
    "question": "A company deletes all AI logs after one month. Which governance risk arises?",
    "choice_a": "Loss of traceability for audits and investigations",
    "choice_b": "Lower storage cost",
    "choice_c": "Improved accuracy",
    "choice_d": "Faster inference",
    "correct_answer": "A",
    "explanation": "Short retention of log data undermines accountability, troubleshooting, and incident investigation.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      596,
      595,
      597,
      213,
      565
    ],
    "source": "363940_PracticeTest_02"
  },
  {
    "id": 304,
    "question": "Why is human oversight essential even in highly automated systems?",
    "choice_a": "Humans remain responsible for ethical and legal outcomes",
    "choice_b": "It slows system response",
    "choice_c": "It reduces scalability",
    "choice_d": "It eliminates monitoring",
    "correct_answer": "A",
    "explanation": "Governance frameworks require human accountability for AI actions, including AI in automated environments.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      42,
      60,
      123,
      104,
      61
    ],
    "source": "363940_PracticeTest_02"
  },
  {
    "id": 305,
    "question": "A company classifies AI risks using both likelihood and impact. What framework is this based on?",
    "choice_a": "Risk-management matrix approach",
    "choice_b": "Quantization model",
    "choice_c": "Fairness matrix",
    "choice_d": "Vendor-tiering",
    "correct_answer": "A",
    "explanation": "A likelihood-impact assessment prioritizes risks and their treatment.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      429,
      565,
      427,
      595,
      547
    ],
    "source": "363940_PracticeTest_02"
  },
  {
    "id": 306,
    "question": "An AI platform automatically flags model anomalies for a risk committee. What does this demonstrate?",
    "choice_a": "Integrated governance and monitoring process",
    "choice_b": "Lack of maturity",
    "choice_c": "Manual reporting",
    "choice_d": "Vendor isolation",
    "correct_answer": "A",
    "explanation": "Automated alerts support continuous oversight and risk governance.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      547,
      565,
      596,
      430,
      278
    ],
    "source": "363940_PracticeTest_02"
  },
  {
    "id": 307,
    "question": "Which NIST AI RMF function involves defining metrics to evaluate AI trustworthiness?",
    "choice_a": "Map",
    "choice_b": "Manage",
    "choice_c": "Govern",
    "choice_d": "Measure",
    "correct_answer": "D",
    "explanation": "The “Measure” function sets performance, bias, and reliability metrics for AI assessment.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      352,
      349,
      178,
      374,
      354
    ],
    "source": "363940_PracticeTest_02"
  },
  {
    "id": 308,
    "question": "An AI model for recruitment uses local dialects in screening interviews. Why might this raise compliance issues?",
    "choice_a": "Voice data reduces accuracy",
    "choice_b": "Language bias may disadvantage certain groups",
    "choice_c": "Audio models are unregulated",
    "choice_d": "Candidates expect automation",
    "correct_answer": "B",
    "explanation": "Dialect-based features can encode bias, violating fairness and equality principles.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      255,
      254,
      211,
      257,
      311
    ],
    "source": "363940_PracticeTest_02"
  },
  {
    "id": 309,
    "question": "An AI system updates its model automatically from live data feeds. Which control ensures safe operation?",
    "choice_a": "Manual override disabled",
    "choice_b": "Shadow-mode launch",
    "choice_c": "Continuous testing and approval workflow",
    "choice_d": "Marketing validation",
    "correct_answer": "C",
    "explanation": "Automated updates require continuous testing, monitoring, validation, and oversight.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      546,
      547,
      596,
      565,
      431
    ],
    "source": "363940_PracticeTest_02"
  },
  {
    "id": 310,
    "question": "Why should AI governance require explainability by design?",
    "choice_a": "To speed deployment",
    "choice_b": "To increase confidentiality",
    "choice_c": "To avoid regulation",
    "choice_d": "To make decisions understandable and auditable from inception",
    "correct_answer": "D",
    "explanation": "Explainability by design helps stakeholders understand and review how an AI system produces or supports decisions. Incorporating it from the outset promotes transparency, accountability, effective oversight, auditability, and regulatory readiness.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      405,
      403,
      465,
      496,
      416
    ],
    "source": "363940_PracticeTest_02"
  },
  {
    "id": 311,
    "question": "An AI-generated art tool mimics the style of living artists. What legal area may apply?",
    "choice_a": "Export control",
    "choice_b": "Intellectual property and moral rights",
    "choice_c": "Labor law",
    "choice_d": "Environmental regulation",
    "correct_answer": "B",
    "explanation": "Using distinctive artistic styles without consent implicates copyright and moral rights issues.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      235,
      231,
      239,
      237
    ],
    "source": "363940_PracticeTest_02"
  },
  {
    "id": 312,
    "question": "Why should AI documentation specify intended use and limitations?",
    "choice_a": "To meet marketing goals",
    "choice_b": "To reduce compute load",
    "choice_c": "To minimize user feedback",
    "choice_d": "To prevent misuse and support transparency",
    "correct_answer": "D",
    "explanation": "Clarifying scope prevents unintended use and unsafe applications.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      564,
      606,
      608,
      215
    ],
    "source": "363940_PracticeTest_02"
  },
  {
    "id": 313,
    "question": "A risk team finds inconsistent treatment of vendor-provided models. Which governance process should resolve this?",
    "choice_a": "Developer retraining",
    "choice_b": "Automated tuning",
    "choice_c": "Standardized third-party risk assessment",
    "choice_d": "System deletion",
    "correct_answer": "C",
    "explanation": "Consistent vendor evaluation maintains uniform compliance operations.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      158,
      157,
      161,
      159,
      63
    ],
    "source": "363940_PracticeTest_02"
  },
  {
    "id": 314,
    "question": "A model used to approve loans experiences frequent fairness alerts. What is the immediate governance response?",
    "choice_a": "Deactivate alert thresholds",
    "choice_b": "Trigger an incident review and remediation",
    "choice_c": "Reduce model complexity",
    "choice_d": "Ignore minor drift",
    "correct_answer": "B",
    "explanation": "Bias incidents require documented investigations and corrective actions.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      595,
      547,
      259,
      596,
      587
    ],
    "source": "363940_PracticeTest_02"
  },
  {
    "id": 315,
    "question": "A government AI system categorizes citizens for social scoring. What EU AI Act risk level applies?",
    "choice_a": "Limited risk",
    "choice_b": "High risk",
    "choice_c": "Minimal risk",
    "choice_d": "Prohibited",
    "correct_answer": "D",
    "explanation": "This practice is prohibited under Article 5(1)(c) of the EU AI Act. The system evaluates or classifies people over time based on social behavior, and its scores lead to unjustified or disproportionate unfavorable treatment.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      311,
      317,
      187,
      216,
      332
    ],
    "source": "363940_PracticeTest_02"
  },
  {
    "id": 316,
    "question": "An organization’s AI system includes a manual override for any output. Which governance feature is demonstrated?",
    "choice_a": "Quantization",
    "choice_b": "Transparency notice",
    "choice_c": "Human-in-command oversight",
    "choice_d": "Drift detection",
    "correct_answer": "C",
    "explanation": "Human-in-command oversight ensures that ultimate control of AI-powered processes and systems remains with humans.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      430,
      548,
      259,
      565,
      546
    ],
    "source": "363940_PracticeTest_02"
  },
  {
    "id": 317,
    "question": "Why is localization necessary for globally deployed AI systems?",
    "choice_a": "To improve speed",
    "choice_b": "To simplify training",
    "choice_c": "To align with local legal, cultural, and language contexts",
    "choice_d": "To ensure global uniformity",
    "correct_answer": "C",
    "explanation": "Localization ensures compliance and contextual fairness.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      617,
      259,
      565,
      427,
      597
    ],
    "source": "363940_PracticeTest_02"
  },
  {
    "id": 318,
    "question": "Which ISO standard provides practical guidance on AI risk management?",
    "choice_a": "ISO/IEC 23894",
    "choice_b": "ISO/IEC 27001",
    "choice_c": "ISO/IEC 9004",
    "choice_d": "ISO/IEC 22301",
    "correct_answer": "A",
    "explanation": "ISO/IEC 23894 (“Information technology—Artificial intelligence—Guidance on risk management”) complements governance frameworks with specific AI risk-management principles.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      384,
      382,
      349,
      381,
      395
    ],
    "source": "363940_PracticeTest_02"
  },
  {
    "id": 319,
    "question": "A hospital AI system uses patient data to develop algorithms without explicit consent. Which U.S. law is implicated?",
    "choice_a": "ECOA",
    "choice_b": "HIPAA",
    "choice_c": "FERPA",
    "choice_d": "COPPA",
    "correct_answer": "B",
    "explanation": "HIPAA (Health Insurance Portability and Accountability Act) governs the use of identifiable health information in AI research and services.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      209,
      172,
      173,
      212
    ],
    "source": "363940_PracticeTest_02"
  },
  {
    "id": 320,
    "question": "An AI startup defines KPIs for fairness, accuracy, and reliability. Which governance domain is addressed?",
    "choice_a": "Performance measurement and monitoring",
    "choice_b": "Vendor management",
    "choice_c": "Privacy control",
    "choice_d": "Audit reduction",
    "correct_answer": "A",
    "explanation": "Setting KPIs ensures continuous improvement and measurable accountability.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      444,
      553,
      575,
      554,
      579
    ],
    "source": "363940_PracticeTest_02"
  },
  {
    "id": 321,
    "question": "A chatbot clearly identifies itself to users. What requirement does this satisfy under the EU AI Act?",
    "choice_a": "Human oversight",
    "choice_b": "Record retention",
    "choice_c": "Transparency disclosure for limited-risk AI",
    "choice_d": "Explainability",
    "correct_answer": "C",
    "explanation": "Under the EU AI Act, providers of limited-risk AI systems (such as chatbots) must ensure transparency disclosures, informing users that they are engaging with an AI system rather than a human.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      312,
      318,
      276,
      274,
      297
    ],
    "source": "363940_PracticeTest_02"
  },
  {
    "id": 322,
    "question": "Why should AI project teams conduct pre-mortems?",
    "choice_a": "To justify sunk costs",
    "choice_b": "To assess hardware usage",
    "choice_c": "To anticipate and mitigate potential failures",
    "choice_d": "To eliminate testing",
    "correct_answer": "C",
    "explanation": "Pre-mortems forecast risks early, improving planning and accountability.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      118,
      117,
      122,
      42,
      74
    ],
    "source": "363940_PracticeTest_02"
  },
  {
    "id": 323,
    "question": "An organization reuses pretrained AI models under open-source licenses. Which governance step is vital?",
    "choice_a": "Model quantization",
    "choice_b": "Drift detection",
    "choice_c": "License review and compliance documentation",
    "choice_d": "External audit",
    "correct_answer": "C",
    "explanation": "Open-source models often have redistribution conditions that must be tracked and complied with.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      160,
      159,
      117,
      124,
      148
    ],
    "source": "363940_PracticeTest_02"
  },
  {
    "id": 324,
    "question": "A city government deploys AI to allocate social benefits. Why must human oversight be built in?",
    "choice_a": "To reduce compute time",
    "choice_b": "Because decisions significantly affect individual rights",
    "choice_c": "To improve scalability",
    "choice_d": "To enhance encryption",
    "correct_answer": "B",
    "explanation": "High-impact public AI applications require direct human oversight to ensure fairness, legality, and accountability.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      259,
      430,
      190,
      427,
      429
    ],
    "source": "363940_PracticeTest_02"
  },
  {
    "id": 325,
    "question": "What is the purpose of root cause analysis in AI incident management?",
    "choice_a": "To assign blame",
    "choice_b": "To identify systemic failures and prevent recurrence",
    "choice_c": "To optimize latency",
    "choice_d": "To document metrics",
    "correct_answer": "B",
    "explanation": "Root cause analysis (RCA) findings provide guidance for organizations to strengthen future incident response and governance controls.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      191,
      595,
      547,
      565,
      596
    ],
    "source": "363940_PracticeTest_02"
  },
  {
    "id": 326,
    "question": "A company integrates AI logs into its enterprise SIEM. What advantage does this create?",
    "choice_a": "Reduced accuracy",
    "choice_b": "Centralized visibility for compliance and incident response",
    "choice_c": "Lower inference cost",
    "choice_d": "Faster training",
    "correct_answer": "B",
    "explanation": "Consolidating logs on a SIEM (security information and event management system) supports traceability and unified risk detection.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      597,
      547,
      595,
      596,
      191
    ],
    "source": "363940_PracticeTest_02"
  },
  {
    "id": 327,
    "question": "A facial-recognition AI misidentifies individuals of certain ethnicities. What governance process should be activated?",
    "choice_a": "Quantization testing",
    "choice_b": "Data compression",
    "choice_c": "Bias remediation and fairness audit",
    "choice_d": "Vendor licensing",
    "correct_answer": "C",
    "explanation": "Bias findings trigger formal incident analysis and retraining of the AI model.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      507,
      585,
      586,
      554
    ],
    "source": "363940_PracticeTest_02"
  },
  {
    "id": 328,
    "question": "Why should AI governance policies define retention schedules for model data?",
    "choice_a": "To improve accuracy",
    "choice_b": "To ensure compliance with storage-limitation principles",
    "choice_c": "To enable faster inference",
    "choice_d": "To minimize testing",
    "correct_answer": "B",
    "explanation": "Data must not be retained longer than necessary to fulfill lawful purposes.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      176,
      181,
      182,
      316,
      177
    ],
    "source": "363940_PracticeTest_02"
  },
  {
    "id": 329,
    "question": "An organization trains AI models using data across multiple countries. What must it confirm?",
    "choice_a": "Lawful cross-border transfer mechanisms",
    "choice_b": "Hardware compatibility",
    "choice_c": "Encryption type",
    "choice_d": "Model explainability",
    "correct_answer": "A",
    "explanation": "Compliance requires verifying data-transfer safeguards in accordance with privacy and data-residency laws.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      189,
      181,
      188,
      187,
      316
    ],
    "source": "363940_PracticeTest_02"
  },
  {
    "id": 330,
    "question": "Which document shows risk treatment, owners, and review dates for AI systems?",
    "choice_a": "Risk register",
    "choice_b": "DPIA",
    "choice_c": "Model card",
    "choice_d": "Data inventory",
    "correct_answer": "A",
    "explanation": "A risk register consolidates vulnerabilities, threats, risk scoring, risk treatment, mitigations, and accountability.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      595,
      547,
      565,
      596,
      431
    ],
    "source": "363940_PracticeTest_02"
  },
  {
    "id": 331,
    "question": "A transportation company’s AI-powered navigation system fails during storms. What testing method would expose this?",
    "choice_a": "Unit testing",
    "choice_b": "Random sampling",
    "choice_c": "Hyperparameter tuning",
    "choice_d": "Environmental-stress and edge-case testing",
    "correct_answer": "D",
    "explanation": "Edge-case tests simulate extreme or unexpected conditions to assess safety.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      547,
      564,
      429,
      565,
      595
    ],
    "source": "363940_PracticeTest_02"
  },
  {
    "id": 332,
    "question": "A startup launches an AI service globally with identical models in all regions. Which risk is highest?",
    "choice_a": "Over-training",
    "choice_b": "Non-compliance with local privacy or content laws",
    "choice_c": "Slow inference",
    "choice_d": "Increased transparency",
    "correct_answer": "B",
    "explanation": "Governance requires localization to meet jurisdiction-specific legal and ethical standards.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      617,
      597,
      427,
      565,
      587
    ],
    "source": "363940_PracticeTest_02"
  },
  {
    "id": 333,
    "question": "An AI maintenance team notices drift in prediction accuracy. What is the best mitigation step?",
    "choice_a": "Lower monitoring thresholds",
    "choice_b": "Disable alerts",
    "choice_c": "Extend model life indefinitely",
    "choice_d": "Retrain with updated, validated data",
    "correct_answer": "D",
    "explanation": "Scheduled retraining restores performance as data relationships change.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      547,
      564,
      565,
      596,
      595
    ],
    "source": "363940_PracticeTest_02"
  },
  {
    "id": 334,
    "question": "A regulator requests the organization’s AI governance charter. What does this document contain?",
    "choice_a": "Technical weights",
    "choice_b": "Hyperparameter settings",
    "choice_c": "Roles, responsibilities, and oversight structure",
    "choice_d": "Marketing messages",
    "correct_answer": "C",
    "explanation": "A governance charter defines accountability, decision authority, and business processes.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      60,
      61,
      63,
      75,
      117
    ],
    "source": "363940_PracticeTest_02"
  },
  {
    "id": 335,
    "question": "An AI project integrates bias-detection tools during training. What outcome is achieved?",
    "choice_a": "Reduced compute speed",
    "choice_b": "Higher marketing engagement",
    "choice_c": "Simpler contracts",
    "choice_d": "Early identification of discriminatory patterns",
    "correct_answer": "D",
    "explanation": "Early bias testing improves fairness and reduces costly rework later.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      507,
      520,
      404,
      452
    ],
    "source": "363940_PracticeTest_02"
  },
  {
    "id": 336,
    "question": "Which NIST AI RMF function covers periodic risk review and improvement?",
    "choice_a": "Measure",
    "choice_b": "Map",
    "choice_c": "Manage",
    "choice_d": "Govern",
    "correct_answer": "C",
    "explanation": "The “Manage” function in NIST AI RMF (National Institute of Standards and Technology AI Risk Management Framework) focuses on continuous risk mitigation and iterative improvement.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      353,
      349,
      354,
      352,
      178
    ],
    "source": "363940_PracticeTest_02"
  },
  {
    "id": 337,
    "question": "A training dataset includes sensitive health attributes. Which privacy safeguard is required?",
    "choice_a": "Data deduplication",
    "choice_b": "Hashing of filenames",
    "choice_c": "Quantization",
    "choice_d": "Explicit consent or lawful processing basis",
    "correct_answer": "D",
    "explanation": "Special-category data demands consent or an authorized exception.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      212,
      207,
      209,
      216,
      172
    ],
    "source": "363940_PracticeTest_02"
  },
  {
    "id": 338,
    "question": "A multinational’s AI procurement policy requires vendors to submit audit results annually. What does this promote?",
    "choice_a": "Ongoing third-party assurance",
    "choice_b": "Vendor lock-in",
    "choice_c": "Model simplification",
    "choice_d": "Cost reduction",
    "correct_answer": "A",
    "explanation": "Periodic vendor audits maintain accountability and trust in external AI providers.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      158,
      161,
      159,
      157,
      124
    ],
    "source": "363940_PracticeTest_02"
  },
  {
    "id": 339,
    "question": "An AI incident results in public harm. What immediate governance requirement applies?",
    "choice_a": "Marketing suppression",
    "choice_b": "Model retraining only",
    "choice_c": "Staff termination",
    "choice_d": "Incident logging and timely regulator notification",
    "correct_answer": "D",
    "explanation": "Serious incidents must be documented and reported in accordance with defined reporting rules.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      607,
      595,
      191,
      587,
      565
    ],
    "source": "363940_PracticeTest_02"
  },
  {
    "id": 340,
    "question": "Why should organizations maintain version control for AI models?",
    "choice_a": "To reduce data storage",
    "choice_b": "To reproduce results and track performance over time",
    "choice_c": "To obscure lineage",
    "choice_d": "To simplify licenses",
    "correct_answer": "B",
    "explanation": "Version control provides auditability, easier troubleshooting, and rollback capability.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      405,
      404,
      465,
      553,
      536
    ],
    "source": "363940_PracticeTest_02"
  },
  {
    "id": 341,
    "question": "Which ISO standard establishes a certifiable AI management system framework?",
    "choice_a": "ISO/IEC 22989",
    "choice_b": "ISO/IEC 23894",
    "choice_c": "ISO/IEC 42001",
    "choice_d": "ISO/IEC 27017",
    "correct_answer": "C",
    "explanation": "ISO/IEC 42001 (“Information technology—Artificial intelligence—Management system”) formalizes AI governance using the Plan-Do-Check-Act model.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      382,
      383,
      384,
      381,
      395
    ],
    "source": "363940_PracticeTest_02"
  },
  {
    "id": 342,
    "question": "An AI system that predicts employee success rates is used for promotions without human review. Which risk emerges?",
    "choice_a": "Automation bias and discrimination",
    "choice_b": "Data redundancy",
    "choice_c": "Latency increase",
    "choice_d": "Fair-use protection",
    "correct_answer": "A",
    "explanation": "Human oversight prevents unjustified or biased employment-related decisions.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      430,
      259,
      429,
      214,
      547
    ],
    "source": "363940_PracticeTest_02"
  },
  {
    "id": 343,
    "question": "A bank’s AI-powered credit model shows declining fairness scores. What governance step follows?",
    "choice_a": "Disable alerts",
    "choice_b": "Publish model weights",
    "choice_c": "Remove training logs",
    "choice_d": "Initiate corrective bias-remediation process",
    "correct_answer": "D",
    "explanation": "Governance frameworks require monitoring, investigation, and mitigation of fairness deviations.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      547,
      259,
      596,
      595,
      430
    ],
    "source": "363940_PracticeTest_02"
  },
  {
    "id": 344,
    "question": "A software vendor’s AI system logs include personal identifiers. Which privacy principle is violated?",
    "choice_a": "Accuracy",
    "choice_b": "Integrity",
    "choice_c": "Data minimization",
    "choice_d": "Accountability",
    "correct_answer": "C",
    "explanation": "Collecting and propagating data that are not essential to the purpose violates minimization principles.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      176,
      181,
      177,
      178,
      187
    ],
    "source": "363940_PracticeTest_02"
  },
  {
    "id": 345,
    "question": "What is the chief purpose of federated learning in AI governance?",
    "choice_a": "Increase model size",
    "choice_b": "Preserve data sovereignty while enabling collaboration",
    "choice_c": "Reduce fairness metrics",
    "choice_d": "Simplify documentation",
    "correct_answer": "B",
    "explanation": "Federated learning keeps local raw data private while sharing only model parameters/gradients.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      213,
      617,
      546,
      565,
      597
    ],
    "source": "363940_PracticeTest_02"
  },
  {
    "id": 346,
    "question": "A company’s AI dashboard tracks regulatory changes by region. What does this enable?",
    "choice_a": "Model quantization",
    "choice_b": "Network scaling",
    "choice_c": "Fairness bias injection",
    "choice_d": "Dynamic compliance adaptation",
    "correct_answer": "D",
    "explanation": "Monitoring evolving laws maintains ongoing conformity across jurisdictions.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      565,
      607,
      427,
      596,
      587
    ],
    "source": "363940_PracticeTest_02"
  },
  {
    "id": 347,
    "question": "An insurance firm defines AI ethics KPIs in its annual reports. Which governance principle does this support?",
    "choice_a": "Proprietary secrecy",
    "choice_b": "Vendor exclusivity",
    "choice_c": "Transparency and accountability to stakeholders",
    "choice_d": "Reduced documentation",
    "correct_answer": "C",
    "explanation": "Public disclosure of ethics metrics demonstrates responsible oversight.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      124,
      41,
      42,
      89,
      75
    ],
    "source": "363940_PracticeTest_02"
  },
  {
    "id": 348,
    "question": "A dataset’s license forbids commercial reuse, but an AI startup trains a product on it. Which issue results?",
    "choice_a": "License violation and IP infringement",
    "choice_b": "Concept drift",
    "choice_c": "Compression error",
    "choice_d": "False positives",
    "correct_answer": "A",
    "explanation": "Governance requires verifying usage rights to prevent contractual or legal compliance issues.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      159,
      120,
      61,
      63,
      117
    ],
    "source": "363940_PracticeTest_02"
  },
  {
    "id": 349,
    "question": "Which mechanism ensures audit logs cannot be retroactively altered?",
    "choice_a": "Shared-drive editing",
    "choice_b": "Manual backups",
    "choice_c": "Immutable append-only storage",
    "choice_d": "Cloud mirroring",
    "correct_answer": "C",
    "explanation": "Immutable logs preserve record integrity for compliance audits and investigations.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      213,
      596,
      546,
      595,
      565
    ],
    "source": "363940_PracticeTest_02"
  },
  {
    "id": 350,
    "question": "A system’s training dataset omits key demographic groups. What risk arises?",
    "choice_a": "Increased transparency",
    "choice_b": "Lower storage cost",
    "choice_c": "Reduced fairness and generalizability",
    "choice_d": "Faster inference",
    "correct_answer": "C",
    "explanation": "Excluding groups from training data may introduce bias and weaken performance across populations.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      481,
      520,
      507,
      554,
      562
    ],
    "source": "363940_PracticeTest_02"
  },
  {
    "id": 351,
    "question": "Which AI category under the EU AI Act requires only transparency obligations?",
    "choice_a": "High-risk systems",
    "choice_b": "Limited-risk systems",
    "choice_c": "Minimal-risk systems",
    "choice_d": "Prohibited systems",
    "correct_answer": "B",
    "explanation": "Organizations using limited-risk AI (for example, chatbots) must disclose AI interactions but are not required to undergo audits.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      312,
      318,
      311,
      317,
      322
    ],
    "source": "363940_PracticeTest_02"
  },
  {
    "id": 352,
    "question": "A post-deployment AI model produces unexpected, harmful content. Which governance mechanism is activated?",
    "choice_a": "Incident-response and disclosure process",
    "choice_b": "Model retraining only",
    "choice_c": "Vendor de-listing",
    "choice_d": "Data augmentation",
    "correct_answer": "A",
    "explanation": "Governance mandates structured incident investigation and regulator notification.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      191,
      587,
      607,
      547,
      595
    ],
    "source": "363940_PracticeTest_02"
  },
  {
    "id": 353,
    "question": "A new AI privacy law introduces stricter consent standards. What should the governance office do first?",
    "choice_a": "Pause all AI projects",
    "choice_b": "Update policies and DPIA templates",
    "choice_c": "Increase model size",
    "choice_d": "Reduce training data",
    "correct_answer": "B",
    "explanation": "Governance must adapt documentation and workflows to comply with regulatory changes.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      182,
      187,
      177,
      181,
      192
    ],
    "source": "363940_PracticeTest_02"
  },
  {
    "id": 354,
    "question": "Why must AI governance programs include staff training?",
    "choice_a": "To accelerate modeling",
    "choice_b": "To satisfy compute requirements",
    "choice_c": "To improve UI design",
    "choice_d": "To ensure awareness of ethical, legal, and procedural duties",
    "correct_answer": "D",
    "explanation": "Education promotes consistent, informed behavior for all personnel who manage and interact with AI systems.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      87,
      89,
      88,
      60,
      74
    ],
    "source": "363940_PracticeTest_02"
  },
  {
    "id": 355,
    "question": "A company maps each AI risk to specific business objectives. What advantage results?",
    "choice_a": "Reduces monitoring cost",
    "choice_b": "Eliminates compliance",
    "choice_c": "Improves latency",
    "choice_d": "Aligns AI risk management with enterprise strategy",
    "correct_answer": "D",
    "explanation": "Linking AI risks to strategic goals embeds governance into core management.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      414,
      453,
      450,
      467,
      442
    ],
    "source": "363940_PracticeTest_02"
  },
  {
    "id": 356,
    "question": "After decommissioning an AI model, what should be retained?",
    "choice_a": "All personal data",
    "choice_b": "Governance documentation and audit logs",
    "choice_c": "Marketing assets",
    "choice_d": "Training hardware",
    "correct_answer": "B",
    "explanation": "Lifecycle evidence must be preserved for accountability and legal defense. Records retention regulations apply to active and retired systems.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      618,
      596,
      616,
      597,
      595
    ],
    "source": "363940_PracticeTest_02"
  }
];
